<template>
  <v-sheet class="fill-height" tile color="white">
    <v-container fluid>
      <v-expand-transition>
        <div v-if="compare" key="compare" class="compare-info">
          <v-btn text color="primary" @click="cancelCompare"> cancel</v-btn>
          <div class="text-center">
            <v-icon color="primary" class="hidden-sm-and-down" left>compare_arrows</v-icon>
            <span class="title">Comparing <span class="hidden-sm-and-down"> {{compare_display_label}}</span></span>

          </div>
          <FullscreenModalWithSlot v-if="compare" :dense="true" :persistent="false"
                                   :closing_btn_disabled="applyDisabled"
                                   @opened="toggleOverlay"
                                   @closed="toggleOverlay" @closed_primary="compareStores">
            <template v-slot:activator>
              <v-btn outlined color="primary">
                <v-icon left>compare_arrows</v-icon>
                {{compare? 'Edit ':'Compare'}}
              </v-btn>
            </template>
            <template v-slot:content>
              <v-card tile flat height="380">
                <v-card-title>Compare</v-card-title>
                <div class="text-center" v-if="dashboard_mode === 'store_in_brand'">
                  <v-btn-toggle mandatory v-model="compare_param" class="compare-dates mb-4 mx-2">
                    <v-btn
                      min-width="128"
                      active-class="compare_mode_active"
                      value="Dates"
                      @click="compare_param = 'Dates'"
                      depressed
                      outlined
                    >
                      Dates
                    </v-btn>
                    <v-btn
                      min-width="128"
                      active-class="compare_mode_active"
                      value="Stores"
                      @click="compare_param = 'Stores'"
                      depressed
                      outlined
                    >
                      Stores
                    </v-btn>

                  </v-btn-toggle>
                </div>
                <div class="btn-toggle-container text-center">
                  <v-btn-toggle mandatory v-model="compare_mods_slider" class="compare-dates mb-1 mx-2"
                                @change="compareModeChanged">
                    <v-btn
                      :disabled="compare_mode.disabled" v-for="(compare_mode,index) in compare_mods"
                      :key="compare_mode.title"
                      :value="index"
                      @click="compare_mods_slider = index"
                      active-class="compare_mode_active"
                      depressed
                      outlined
                    >
                      {{compare_mode.title}}
                    </v-btn>
                  </v-btn-toggle>

                </div>
                <v-dialog
                  ref="compare_date_first"
                  v-model="compare_date_first"
                  :return-value.sync="dateA"
                  persistent
                  width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="pa-3">
                      <v-text-field
                        hide-details
                        :value="formattedDate(dateA)"
                        placeholder="Select First Date"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on">
                        <template v-slot:prepend-inner>
                          <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>
                            {{adjustedComparisonTitle('')}}
                          </v-chip>
                        </template>
                        <template v-slot:append>
                          <v-icon color="primary">expand_more</v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </template>
                  <template>
                    <v-date-picker first-day-of-week="1"

                                   :allowed-dates="compare_mods_slider === 1 ? allowedDates : allDates"
                                   prev-icon="arrow_back_ios"
                                   next-icon="arrow_forward_ios"
                                   :value="pickerValue(dateA)"
                                   no-title
                                   reactive
                                   @input="saveDate('compare_date_first',dateA)"
                                   ref="dateA"
                                   color="primary"
                                   v-model="dateA"
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="compare_date_first = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="compareDates('compare_date_first',dateA)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </template>
                </v-dialog>
                <transition name="slide-y-transition" mode="out-in">
                  <v-dialog v-if="compare_param == 'Dates'"
                            key="date"
                            ref="compare_date_second"
                            v-model="compare_date_second"
                            :return-value.sync="dateB"
                            persistent
                            width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="px-3">
                        <v-text-field
                          :value="formattedDate(dateB)"
                          placeholder="Select Second Date"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on">
                          <template v-slot:prepend-inner>
                            <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>To
                            </v-chip>
                          </template>
                          <template v-slot:append>
                            <v-icon color="primary">expand_more</v-icon>
                          </template>
                        </v-text-field>

                      </div>

                    </template>
                    <v-date-picker
                      first-day-of-week="1" prev-icon="arrow_back_ios"
                      :allowed-dates="compare_mods_slider === 1 ? allowedDates : allDates"
                      next-icon="arrow_forward_ios"
                      :value="pickerValue(dateB)"
                      no-title
                      @input="saveDate('compare_date_second',dateB)"
                      reactive
                      ref="dateB"
                      color="primary"
                      v-model="dateB"
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="compare_date_second = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="compareDates('compare_date_second',dateB)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <div class="px-3" v-if="compare_param == 'Stores'">
                    <v-select
                      key="store"
                      return-object
                      item-value="id"
                      item-text="name"
                      placeholder="Select Store"
                      outlined
                      v-model="store_to_compare_object"
                      :items="allStoresInCurrentBrand"
                    >
                      <template v-slot:item="{item,on, attrs}">

                        <v-list-item v-on="on" v-bind="attrs" class="custom-store-selector">
                          <v-list-item-title>
                            {{item.name}}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-icon small>place</v-icon>
                            {{item.address}}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </template>

                      <template v-slot:prepend-inner>
                        <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>Store
                        </v-chip>
                      </template>
                      <template v-slot:append>
                        <v-icon color="primary">expand_more</v-icon>
                      </template>
                    </v-select>

                  </div>

                </transition>

              </v-card>
            </template>
            <template v-slot:closing-btn-title>
              Compare
            </template>
          </FullscreenModalWithSlot>
        </div>
        <DashboardTimeSlider v-else key="date-picker" @mode_changed="modeChanged"/>

      </v-expand-transition>
      <v-spacer v-if="compare" style="height:56px"></v-spacer>
      <v-fade-transition mode="out-in">
        <div :class="['dashboard-content',dashboard_mode]" :key="$route.path">
          <div class="store-title align-center">

            <div v-if="dashboard_mode === 'store'" class="pt-4">
              <v-list-item v-if="!compare">

                <v-list-item-content class="title-store">
                  <v-list-item-title class=" title primary--text">{{store.name}}</v-list-item-title>
                  <v-list-item-subtitle class="black--text">{{store.address}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else>

                <v-list-item-content>
                  <v-list-item-title style="white-space: normal;" class="title primary--text">
                    {{store.name}}
                  </v-list-item-title>
                  <v-list-item-title style="white-space: normal;" class="title primary--text">
                    {{formattedDate(dateA)}}<span
                    class="secondary--text"> vs </span>{{formattedDate(dateB)}}
                  </v-list-item-title>
                </v-list-item-content>

              </v-list-item>
            </div>
            <template v-else>
              <v-menu v-if="!compare" transition="slide-y-transition" offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-card v-on="on" max-width="334" outlined class="title-name-card primary--text pa-2">

                    <template v-if="dashboard_mode === 'brand'">

                      <div class="title-name primary--text">
                        <v-btn depressed small fab color="primary" class="mr-2">
                          <v-icon>shopping_bag</v-icon>
                        </v-btn>
                        <v-row>
                          <div>All Stores</div>
                          <v-icon class="ml-auto px-2" large color="primary">keyboard_arrow_down</v-icon>
                        </v-row>

                      </div>
                    </template>
                    <template v-if="dashboard_mode === 'store_in_brand'">

                      <v-list-item v-if="!compare" class="px-0">
                        <v-list-item-avatar class="avatar small">
                          <SpotS3Image :image-path="brand.image"></SpotS3Image>
                        </v-list-item-avatar>
                        <v-list-item-content class="title-store">
                          <v-list-item-title class=" title primary--text">{{store.name}}</v-list-item-title>
                          <v-list-item-subtitle class="black--text">{{store.address}}</v-list-item-subtitle>
                          <v-icon class="ml-auto px-2" large color="primary">keyboard_arrow_down</v-icon>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-else>
                        <v-list-item-avatar class="avatar small overflow-visible">
                          <SpotS3Image class="overflowing-image" :image-path="brand.image"></SpotS3Image>
                          <SpotS3Image :image-path="brand.image"></SpotS3Image>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title style="white-space: normal;" class="title primary--text">
                            {{store.name}}<span
                            class="secondary--text"> vs </span>{{store_to_compare}}
                          </v-list-item-title>
                        </v-list-item-content>

                      </v-list-item>
                    </template>
                  </v-card>

                </template>
                <v-list>
                  <dashboard-store-search/>
                </v-list>
              </v-menu>
              <template v-else>
                <div>
                  <v-card-title class="gray--text">
                    Total Registered
                  </v-card-title>
                  <v-card-subtitle class="hidden-md-and-up primary--text">
                    {{compare_display_label === 'Dates' ? store.name : formattedDate(dateA)}}
                  </v-card-subtitle>
                </div>

              </template>
            </template>

            <FullscreenModalWithSlot v-if="!compare" :dense="true" :persistent="false"
                                     :closing_btn_disabled="applyDisabled"
                                     @opened="toggleOverlay"
                                     @closed="toggleOverlay" @closed_primary="compareStores">
              <template v-slot:activator>
                <v-btn outlined color="primary">
                  <v-icon left>compare_arrows</v-icon>
                  {{compare? 'Edit ':'Compare'}}
                </v-btn>
              </template>
              <template v-slot:content>
                <v-card tile flat height="380">
                  <v-card-title>Compare</v-card-title>
                  <div class="text-center" v-if="dashboard_mode === 'store_in_brand'">
                    <v-btn-toggle mandatory v-model="compare_param" class="compare-dates mb-4 mx-2">
                      <v-btn
                        min-width="128"
                        active-class="compare_mode_active"
                        value="Dates"
                        @click="compare_param = 'Dates'"
                        depressed
                        outlined
                      >
                        Dates
                      </v-btn>
                      <v-btn
                        min-width="128"
                        active-class="compare_mode_active"
                        value="Stores"
                        @click="compare_param = 'Stores'"
                        depressed
                        outlined
                      >
                        Stores
                      </v-btn>

                    </v-btn-toggle>
                  </div>
                  <div class="btn-toggle-container text-center">
                    <v-btn-toggle mandatory v-model="compare_mods_slider" class="compare-dates mb-1 mx-2"
                                  @change="compareModeChanged">
                      <v-btn
                        :disabled="compare_mode.disabled" v-for="(compare_mode,index) in compare_mods"
                        :key="compare_mode.title"
                        :value="index"
                        @click="compare_mods_slider = index"
                        active-class="compare_mode_active"
                        depressed
                        outlined
                      >
                        {{compare_mode.title}}
                      </v-btn>
                    </v-btn-toggle>

                  </div>
                  <v-dialog
                    ref="compare_date_first"
                    v-model="compare_date_first"
                    :return-value.sync="dateA"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="pa-3">
                        <v-text-field
                          hide-details
                          :value="formattedDate(dateA)"
                          placeholder="Select First Date"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on">
                          <template v-slot:prepend-inner>
                            <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>
                              {{adjustedComparisonTitle('')}}
                            </v-chip>
                          </template>
                          <template v-slot:append>
                            <v-icon color="primary">expand_more</v-icon>
                          </template>
                        </v-text-field>
                      </div>
                    </template>
                    <template>
                      <v-date-picker first-day-of-week="1"

                                     :allowed-dates="compare_mods_slider === 1 ? allowedDates : allDates"
                                     prev-icon="arrow_back_ios"
                                     next-icon="arrow_forward_ios"
                                     :value="pickerValue(dateA)"
                                     no-title
                                     reactive
                                     @input="saveDate('compare_date_first',dateA)"
                                     ref="dateA"
                                     color="primary"
                                     v-model="dateA"
                                     scrollable>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="compare_date_first = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="compareDates('compare_date_first',dateA)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </template>
                  </v-dialog>
                  <transition name="slide-y-transition" mode="out-in">
                    <v-dialog v-if="compare_param == 'Dates'"
                              key="date"
                              ref="compare_date_second"
                              v-model="compare_date_second"
                              :return-value.sync="dateB"
                              persistent
                              width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="px-3">
                          <v-text-field
                            :value="formattedDate(dateB)"
                            placeholder="Select Second Date"
                            readonly
                            outlined
                            v-bind="attrs"
                            v-on="on">
                            <template v-slot:prepend-inner>
                              <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>To
                              </v-chip>
                            </template>
                            <template v-slot:append>
                              <v-icon color="primary">expand_more</v-icon>
                            </template>
                          </v-text-field>

                        </div>

                      </template>
                      <v-date-picker
                        first-day-of-week="1" prev-icon="arrow_back_ios"
                        :allowed-dates="compare_mods_slider === 1 ? allowedDates : allDates"
                        next-icon="arrow_forward_ios"
                        :value="pickerValue(dateB)"
                        no-title
                        @input="saveDate('compare_date_second',dateB)"
                        reactive
                        ref="dateB"
                        color="primary"
                        v-model="dateB"
                        scrollable>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="compare_date_second = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="compareDates('compare_date_second',dateB)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                    <div class="px-3" v-if="compare_param == 'Stores'">
                      <v-select
                        key="store"
                        return-object
                        item-value="id"
                        item-text="name"
                        placeholder="Select Store"
                        outlined
                        v-model="store_to_compare_object"
                        :items="allStoresInCurrentBrand"
                      >
                        <template v-slot:item="{item,on, attrs}">

                          <v-list-item v-on="on" v-bind="attrs" class="custom-store-selector">
                            <v-list-item-title>
                              {{item.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-icon small>place</v-icon>
                              {{item.address}}
                            </v-list-item-subtitle>
                          </v-list-item>
                        </template>

                        <template v-slot:prepend-inner>
                          <v-chip text-color="#C4C4C4" color="transparent" style="margin-top: -4px;" label>Store
                          </v-chip>
                        </template>
                        <template v-slot:append>
                          <v-icon color="primary">expand_more</v-icon>
                        </template>
                      </v-select>

                    </div>

                  </transition>

                </v-card>
              </template>
              <template v-slot:closing-btn-title>
                Compare
              </template>
            </FullscreenModalWithSlot>

          </div>
          <div class="bordered-card mt-4 mb-6">
            <div class="upper-content" v-if="dashboard_mode === 'store' && !compare">


              <DashboardVisitorsForecastCards
                :loading="currently_in_store_loading" :store="store"
                :currently_in_store="currently_in_store"
                :coming_today="visitors_for_today"
                :coming_next_30_minutes="coming_next_30_minutes"/>


            </div>
            <template>
              <div :class="['chart-container', compare ? 'compared':'']">

                <template>
                  <div class="chart-content" v-if="!compare">
                    <ChartBar ref="visitorsChart" :dashboardLoaded="dashboardLoaded" :chartdata="chartdataVisitors" :options="settingsVisitors"/>
                  </div>
                  <div class="chart-content" v-else>
                    <div class="chart-label-top">

                      <div class="font-weight-bold">
                        <v-list-item-avatar v-if="compare_display_label === 'Stores'"
                                            class="avatar small overflow-visible">
                          <SpotS3Image :image-path="brand.image"></SpotS3Image>
                        </v-list-item-avatar>
                        {{compare_display_label === 'Dates' ? formattedDate(dateA) : store.name}}
                      </div>
                      <div class="hidden-sm-and-down">
                        {{compare_display_label === 'Dates' ? store.name : formattedDate(dateA)}}
                      </div>
                    </div>

                    <ChartBar :dashboardLoaded="dashboardLoaded" :chartdata="chartdataVisitors_compare_a"
                              :options="settingsVisitorsComparedA"/>
                  </div>
                  <div class="chart-content compared" v-if="compare">
                    <ChartBar
                              :dashboardLoaded="dashboardLoaded"
                              :chartdata="chartdataVisitors_compare_b"
                              :options="settingsVisitorsComparedB"/>
                    <div class="chart-label-bottom font-weight-bold">
                      <v-list-item-avatar v-if="compare_display_label === 'Stores'"
                                          class="avatar small overflow-visible">
                        <SpotS3Image :image-path="brand.image"></SpotS3Image>
                      </v-list-item-avatar>
                      {{compare_display_label === 'Dates' ? formattedDate(dateB) : store_to_compare}}
                    </div>

                  </div>
                </template>
              </div>
            </template>
            <ReservationsCards @highlight_bar="handleBarClick" v-if="!compare" :total_stats="total_stats"
                               :adjusted_active="adjusted_active"/>
            <v-data-table hide-default-footer disable-pagination
                          v-if="compare && dashboard_mode === 'store_in_brand'"
                          :headers="compareHeaders"
                          :items="compareItems"
                          :items-per-page="5"
                          class="elevation-0">
              <template v-slot:item.name="{item}"><span :class="['item-name', item.name]">
                {{item.name}}</span>
              </template>
              <template v-slot:header.total="{ item }">
                Total
              </template>
              <template v-slot:header.expired="{ item }">
                Expired
                <v-icon style="fill: #E5706C">$rectangle</v-icon>
              </template>
              <template v-slot:header.completed="{ item }">
                Completed
                <v-icon style="fill: #3565BA">$rectangle</v-icon>
              </template>
              <template v-slot:header.active="{ item }">
                Cancelled
                <v-icon style="fill: #8BCA81">$rectangle</v-icon>
              </template>
              <template v-slot:header.cancelled="{ item }">
                Active
                <v-icon style="fill:  #96AAC4">$rectangle</v-icon>
              </template>

              <template v-slot:item.store_1="{ item }">
                {{item.store_1}} <span :class="['ml-4', tableValues(item).positive ? 'positive-num' : 'negative-num']">{{tableValues(item).result}}</span>
              </template>
            </v-data-table>
            <div :class="['visitors-info', compare ? 'compare' :'']"
                 v-if="showVisitors && dashboard_mode === 'store_in_brand'">
              <div class="circular-item">
                <DashboardVisitorsForecastCards v-if="!compare" :loading="currently_in_store_loading" :store="store"
                                                :currently_in_store="currently_in_store"
                                                :coming_today="visitors_for_today"
                                                :coming_next_30_minutes="coming_next_30_minutes"
                />
              </div>

            </div>
          </div>
          <div class="'bottom-charts-container'">
            <div>
              <div class="title gray--text">
                Statistics for selected period
              </div>
              <v-data-table
                :headers="bottom_table_headers"
                :items="per_store_data_for_all_stores"
                disable-pagination
                disable-sort
                hide-default-footer
                disable-filtering>
                <template v-slot:item.total="{ item }">
                  {{item.reservations}}
                </template>
                <template v-slot:item.store="{ item }">
                  {{item.name}}
                </template>
                <template v-slot:item.favorites="{ item }">
                  {{item.favorites}}
                </template>
                <template v-slot:item.repeat_visitors="{ item }">
                  <template
                    v-if="item.repeat_visitors == 0 && item.non_repeat_visitors == 0">
                    -
                  </template>
                  <template v-else>
                    <v-progress-circular color="primary" size="24" width="4"
                                         :value="Math.ceil(100 * item.repeat_visitors / (item.repeat_visitors + item.non_repeat_visitors))">
                    </v-progress-circular>
                    {{ Math.ceil(100 * item.repeat_visitors /
                    (item.repeat_visitors + item.non_repeat_visitors))}}%
                    ({{item.repeat_visitors}})
                  </template>

                </template>
                <template v-slot:item.avg_visit="{item}">
                  <v-row>
                    <div class="avg-visit-int">
                      {{ item.reservations ? Math.ceil(item.visit_duration / item.reservations / 60) : 0}}
                    </div>
                    <v-progress-linear background-opacity="0"
                                       :color="getAvgVisitValue(Math.ceil(item.visit_duration / item.reservations / 60),item.duration) > 100 ? 'error' :'primary'"
                                       style="max-width:100px;" class="avg-visit-progress"
                                       :value="getAvgVisitValue(Math.ceil(item.visit_duration / item.reservations / 60 ),item.duration)">

                    </v-progress-linear>

                  </v-row>

                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-fade-transition>

      <v-overlay v-model="overlay"></v-overlay>


    </v-container>
  </v-sheet>
</template>

<script>
  const _ = require('lodash');
  import {process_api_error} from "@/utils/utils"
  import {fetchItemsNextTokenGraphQL} from "@/utils/query_all_utils";
  import {mapGetters} from "vuex";
  import {RESERVATION_STATUS, determineStatusValue} from "../utils/constants"
  import ChartBar from "../Charts/ChartBar";
  import DashboardTimeSlider from "../Elements/DashboardTimeSlider";
  import DashboardLineCard from "../Elements/DashboardLineCard";
  import LineChart from "../Charts/LineChart";
  import FullscreenModalWithSlot from "../Elements/FullscreenModalWithSlot";
  import AnimatedInteger from "../Elements/AnimatedInteger";
  import {listReservations, listDashboardStoreStats} from "../graphql/queries";
  import Vue from 'vue'
  import {getPrefixFromMoment} from "@/utils/utils"
  import StoreVisitorsCircular from "../Elements/StoreVisitorsCircular";
  import ReservationsCards from "../Elements/ReservationsCards";
  import SpotS3Image from "../Pages/SpotS3Image";
  import HorizontalChartBar from "../Charts/HorizontalChartBar";
  import PieChart from "../Charts/PieChart";
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import DashboardStoreSearch from "../Elements/DashboardStoreSearch";
  import DashboardVisitorsForecastCards from "../Elements/DashboardVisitorsForecastCards";
  import storeDemoResultjson from "../../data/storedatademo.json";
import store from '../store/store';
import { DateTime } from "luxon";

  const moment = require('moment-timezone')
  moment.locale('en', {
    week: {
      dow: 1
    }
  });
  export default {
    name: "StoreDashboard",
    components: {
      DashboardVisitorsForecastCards,
      DashboardStoreSearch,
      vueCustomScrollbar,
      PieChart,
      HorizontalChartBar,
      SpotS3Image,
      ReservationsCards,
      StoreVisitorsCircular,
      AnimatedInteger, FullscreenModalWithSlot, LineChart, DashboardLineCard, DashboardTimeSlider, ChartBar
    },
    watch: {
      compare_date_first(val) {
        val && this.$nextTick(() => (this.$refs.dateA.activePicker = this.compareDataPickerType))
      },
      compare_date_second(val) {
        val && this.$nextTick(() => (this.$refs.dateB.activePicker = this.compareDataPickerType))
      },
      storeId() {
        this.compare = false
        this.store_to_compare = ''
        this.store_to_compare_object = {}
        this.currently_in_store_loading = true;

        this.loadDashboardData(true)
        this.loadCurrentlyInStore()
        this.overlay = false;
      },
      dashboard_mode() {
        this.compare = false
        this.store_to_compare = ''
        this.store_to_compare_object = {}
        this.currently_in_store_loading = true;
        this.loadDashboardData(true)
        this.loadCurrentlyInStore()
      }
    },
    methods: {
      getAvgVisitValue(value, max) {
        let max_visitors = max
        let current = value
        return 100 * current / max_visitors
      },
      swap(array, from, to) {
        if (from !== -1) {
          var temp = array[from];
          array[from] = array[to];
          array[to] = temp;
        }


      },
      handleBarClick(bar) {
        this.highlightBar(bar)
      },
      highlightBar(bar) {
        let datasets = this.chartdataVisitors.datasets
        let highlighted = datasets.filter((dataset) => dataset.label === bar)
        let faded = datasets.filter((dataset) => dataset.label !== bar)
        let highlighted_labels = datasets.filter((dataset) => dataset.label === bar).map((ds) => ds.label.toLowerCase())
        let faded_labels = datasets.filter((dataset) => dataset.label !== bar).map((ds) => ds.label.toLowerCase())
        let datasets_labels = datasets.map((item) => item.label.toLowerCase())
        this.chartdataVisitors.datasets = [...highlighted, ...faded]
        datasets.forEach((item, index, array) => {
          if (bar === 'Total') {
            this[item.label.toLowerCase() + '_faded'] = false
          } else {
            this[item.label.toLowerCase() + '_faded'] = faded_labels.includes(item.label.toLowerCase())
          }
        });
        this.$refs['visitorsChart'].renderChart(this.chartdataVisitors, this.settingsVisitors)


      },
      itemSubtitle(item) {
        if (item.name === 'In Line') {
          return 'Scanned and waiting'
        }
        if (item.name === 'Forecast') {
          return 'Visitors in 30 min'
        }
      },
      tableValues(val) {
        let store_1 = val.store_1
        let store_2 = val.store_2
        let positive = false
        let result = ''
        if (store_1 > store_2) {
          positive = true
          result = `+ ${store_1 - store_2}`
        }
        if (store_1 < store_2) {
          positive = false
          result = `- ${store_2 - store_1}`
        }
        return {result, positive}

      },

      async updateTime() {
        this.current_time = moment.tz(this.store.timezone)
      },
      async loadCurrentlyInStore()
      {
        await Promise.all([this.loadCurrentlyInStoreMain(),this.loadCurrentlyInStoreAdditional()])
        this.currently_in_store_loading = false;
      },
      async loadCurrentlyInStoreMain() {
        var currently_in_store = 0;
        var currently_in_store_expired = 0;

        if (this.store) {
        var result = await fetchItemsNextTokenGraphQL(listReservations, {
          filter: {
            iscancelled: {eq: 0},
            store_id: {eq: this.storeId},
            enterdt: {
              between: [Math.floor(moment().add(-1, "day").unix()), Math.ceil(moment().add(1, "day").unix())]
            },
          },
          limit: 100000
        })

          for (var el of result) {
          if (!el.leavedt) {
            if (moment.unix(el.enterdt) < moment().add(-300, 'minutes')) {

            } else {
              if (moment.unix(el.enterdt) > moment().add(-this.store.minutes_before_out, 'minutes')) {
                currently_in_store += 1;
              } else {
                currently_in_store_expired += 1
              }
            }
          }
        }
        }
        this.currently_in_store = currently_in_store
        this.currently_in_store_expired = currently_in_store_expired
      },
      async loadCurrentlyInStoreAdditional() {
        var coming_next_30_minutes = 0;
        var visitors_for_today = 0
        var adjusted_active = {}
        var start_from = {}
        var end_at = {}
        var query_from = moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).startOf('day').add(-1, 'day')
        var query_to = moment.utc(moment.tz(this.store.timezone).endOf('day').format("YYYY-MM-DDTHH:mm:ss"))
        var next30_end_time = moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(30, 'minute').unix()


        var all_stores = [this.store]
        if (this.dashboard_mode === "brand")
        {
          all_stores = this.allStoresInCurrentBrand
        }

        for (var store of all_stores)
        {
          start_from[store.id] = moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).subtract(this.store.minutes_before_expire, 'minute').unix()
          end_at[store.id] = moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).endOf('day').unix()
        }

        var filter = {
          and:
            {
              iscancelled: {eq: 0},
              dt: {
                between: [query_from.unix(), query_to.unix()]
              },
            }
        }
        if (this.dashboard_mode === 'brand') {
          filter['and']['or'] = []
          for (var br of this.allStoresInCurrentBrand) {
            filter['and']['or'].push({'store_id': {eq: br.id}})
            adjusted_active[br.id]=0
          }
        } else {
          filter['and']['store_id'] = {eq: this.store.id}
          adjusted_active[this.store.id]=0
        }

        var result = await fetchItemsNextTokenGraphQL(listReservations, {
          filter: filter,
          limit: 100000
        })

        var current_start = this.current_mode_data.start * 60 * 60
        var current_end = this.current_mode_data.end * 60 * 60
        if (this.current_mode_data.type !== 0)
        {
          current_start = this.current_mode_data.start * 60 * 60 * 24
          current_end = this.current_mode_data.end * 60 * 60 * 24
        }

        for (var el of result) {
          if (!el.enterdt) {
            if (el.dt >= start_from[el.store_id]) {
              if (el.dt <= next30_end_time) {
                coming_next_30_minutes += 1;
              }
              if (el.dt <= end_at[el.store_id]) {
                visitors_for_today += 1
              }
            }

            if (el.dt >= this.questionable_start[el.store_id] && el.dt < this.questionable_end[el.store_id]) {
              if (el.dt >= start_from[el.store_id] && el.dt >= current_start && el.dt <= current_end) {
                adjusted_active[el.store_id] += 1
              }
            }
          }
        }
        this.visitors_for_today = visitors_for_today
        this.coming_next_30_minutes = coming_next_30_minutes
        this.adjusted_active = adjusted_active
        return result;
      },

      loadDashboardData: _.debounce(async function (with_animation) {

        this.loading_dashboards = with_animation;

        var filter = {
          and:
            {
              dptype: {eq: this.current_mode_data.type},
            }
        }
        var current_start = Math.floor(this.current_mode_data.start)
        var current_end = Math.ceil(this.current_mode_data.end)

        console.log("this.current_mode_data.start : ", this.current_mode_data.start);
        console.log("this.current_mode_data.end : ", this.current_mode_data.end);
        console.log("current start : ", current_start);
        console.log("current start : ", current_end);

        var delta = current_end - current_start + 1
        if (this.dashboard_mode === 'brand') {
          filter['and']['or'] = []
          filter['and']['dpindex'] = {'between': [current_start, current_end]}
          for (var br of this.allStoresInCurrentBrand) {
            filter['and']['or'].push({'store_id': {eq: br.id}})
          }
        } else if (this.dashboard_mode === 'store') {
          filter['and']['store_id'] = {eq: this.store.id}
          filter['and']['dpindex'] = {'between': [current_start - delta, current_end + delta]}
        } else if (this.dashboard_mode === 'store_in_brand') {
          filter['and']['dpindex'] = {'between': [current_start - delta, current_end + delta]}
          filter['and']['store_id'] = {eq: this.store.id}
        }

        var result = null;


        // if(this.$demo === true && this.dashboard_mode === "store"){
        //    result = await fetchItemsNextTokenGraphQL(listDashboardStoreStats, {
        //     filter: filter,
        //     limit: 100000
        //   })
        //     console.log("timeZone : ",this.store.timezone);
        //     var ct = moment();
        //     var selectedDateString = ct.format("YYYY-MM-DDTHH:mm")+":00";
        //     console.log("CurrentDate : ",ct);
        //     console.log("get unix is : ", this.calculateReserveDateTime(selectedDateString));
        //     var tempjson = storeDemoResultjson;
        //     tempjson[0].dpindex = Math.floor(((this.calculateReserveDateTime(selectedDateString)/60)/60)/24);
        //     // tempjson[1].dpindex =tempjson[0].dpindex+1;
        //     tempjson[1].dpindex =tempjson[0].dpindex-1;
        //     result = storeDemoResultjson;
        //     console.log("resuld data 1: ", tempjson);

        // }else{
        //   result = await fetchItemsNextTokenGraphQL(listDashboardStoreStats, {
        //     filter: filter,
        //     limit: 100000
        //   })

        //    console.log("result data 2: ", result);
        // }
        result = await fetchItemsNextTokenGraphQL(listDashboardStoreStats, {
            filter: filter,
            limit: 100000
          })


        var total_stats = {
          'Total': 0,
          'Expired': 0,
          'Completed': 0,
          'Active': 0,
          'Cancelled': 0,
          'Unknown': 0
        }
        var unknown_by_store = {}
        var per_store_data = {}
        var per_store_data_prev = {}
        var per_store_data_next = {}
        var new_current_visitors_total = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visitors_expired = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visitors_completed = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visitors_active = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visitors_cancelled = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_favorites = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_favorites_all_stores_details = new Array(this.allStoresInCurrentBrand.length).fill(0);
        var new_current_total_reservations_all_stores_details = new Array(this.allStoresInCurrentBrand.length).fill(0);

        var new_current_visit_duration = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visit_duration_all_stores_details = new Array(this.allStoresInCurrentBrand.length).fill(0);
        var new_current_visit_duration_divider = new Array(this.current_mode_data.labels.length).fill(0);
        var new_current_visit_duration_all_stores_details_divider = new Array(this.allStoresInCurrentBrand.length).fill(0);
        var new_current_repeat_visitors = [0, 0]
        var store_id_to_index = {}

        for (var i = 0; i < this.allStoresInCurrentBrand.length; i++) {
          store_id_to_index[this.allStoresInCurrentBrand[i].id] = i
        }

        for (var item of result) {
          // item.dpindex = 456498;

          if (item.dpindex >= current_start && item.dpindex <= current_end) {
            var active = item.active - item.cancelled - item.completed
            for (var dp_to_include_index = 0; dp_to_include_index < this.current_mode_data.dp_to_include.length; dp_to_include_index++) {
              if (this.current_mode_data.dp_to_include[dp_to_include_index].includes(item.dpindex)) {
                var dp_store = this.getStoreById(item.store_id)
                var expired_data_point_id_hours_start = Math.floor(moment.utc(moment.tz(dp_store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-dp_store.minutes_before_expire, 'minutes').unix() / 60 / 60)
                var expired_data_point_id_hours_end = expired_data_point_id_hours_start
                var expired_data_point_id_days_start = Math.floor(moment.utc(moment.tz(dp_store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-dp_store.minutes_before_expire, 'minutes').startOf('day').unix() / 60 / 60 / 24);
                var expired_data_point_id_days_end = expired_data_point_id_days_start

                console.log("expired_data_point_id_hours_start : ",expired_data_point_id_hours_start);
                console.log("expired_data_point_id_hours_end : ",expired_data_point_id_hours_end);
                console.log("expired_data_point_id_days_start : ",expired_data_point_id_days_start);
                console.log("expired_data_point_id_days_end : ",expired_data_point_id_days_end);

                total_stats['Total'] += item.active
                total_stats['Cancelled'] += item.cancelled
                total_stats['Completed'] += item.completed
                new_current_repeat_visitors[0] += item.active - item.first
                new_current_repeat_visitors[1] += item.first
                if (this.current_mode_data.type == 0) {
                  if (item.dpindex > expired_data_point_id_hours_end) {
                    total_stats['Active'] += active
                  } else if (item.dpindex < expired_data_point_id_hours_start) {
                    total_stats['Expired'] += active
                  } else {
                    total_stats['Unknown'] += active
                    if (unknown_by_store[item.store_id] === undefined)
                    {
                      unknown_by_store[item.store_id] = 0
                    }
                    unknown_by_store[item.store_id] += active
                  }
                } else {
                  if (item.dpindex > expired_data_point_id_days_end) {
                    total_stats['Active'] += active
                  } else if (item.dpindex < expired_data_point_id_days_start) {
                    total_stats['Expired'] += active
                  } else {
                    total_stats['Unknown'] += active
                    if (unknown_by_store[item.store_id] === undefined)
                    {
                      unknown_by_store[item.store_id] = 0
                    }
                    unknown_by_store[item.store_id] += active
                  }
                }
                if (!(item.store_id in per_store_data)) {
                  per_store_data[item.store_id] = {
                    reservations: 0,
                    visit_duration: 0,
                    repeat_visitors: 0,
                    non_repeat_visitors: 0,
                    favorites: 0
                  }
                }


                var active = item.active - item.cancelled - item.completed
                per_store_data[item.store_id]['reservations'] += item.active;
                per_store_data[item.store_id]['visit_duration'] += item.duration;
                per_store_data[item.store_id]['repeat_visitors'] += item.active - item.first;
                per_store_data[item.store_id]['non_repeat_visitors'] += item.first;
                per_store_data[item.store_id]['favorites'] += item.favorites;

                new_current_visitors_total[dp_to_include_index] += item.active
                new_current_visitors_completed[dp_to_include_index] += item.completed
                new_current_visitors_cancelled[dp_to_include_index] += item.cancelled
                new_current_favorites[dp_to_include_index] += item.favorites
                new_current_favorites_all_stores_details[store_id_to_index[item.store_id]] += item.favorites
                new_current_total_reservations_all_stores_details[store_id_to_index[item.store_id]] += item.active

                new_current_visit_duration[dp_to_include_index] += item.duration
                new_current_visit_duration_all_stores_details[store_id_to_index[item.store_id]] += item.duration

                new_current_visit_duration_divider[dp_to_include_index] += item.completed
                new_current_visit_duration_all_stores_details_divider[store_id_to_index[item.store_id]] += item.completed

                if (this.current_mode_data.type == 0) {
                  if (item.dpindex > expired_data_point_id_hours_end) {
                    new_current_visitors_active[dp_to_include_index] += active
                  } else if (item.dpindex < expired_data_point_id_hours_start) {
                    new_current_visitors_expired[dp_to_include_index] += active
                  }
                } else {
                  if (item.dpindex > expired_data_point_id_days_end) {
                    new_current_visitors_active[dp_to_include_index] += active
                  } else if (item.dpindex < expired_data_point_id_days_start) {
                    new_current_visitors_expired[dp_to_include_index] += active
                  }
                }
              }
            }
          }
        }
        for (var item of result) {
          if (item.dpindex < current_start) {
            if (!(item.store_id in per_store_data_prev)) {
              per_store_data_prev[item.store_id] = {
                reservations: 0,
                visit_duration: 0,
                repeat_visitors: 0,
                non_repeat_visitors: 0,
                favorites: 0
              }
            }
            per_store_data_prev[item.store_id]['reservations'] += item.active;
            per_store_data_prev[item.store_id]['visit_duration'] += item.duration;
            per_store_data_prev[item.store_id]['repeat_visitors'] += item.active - item.first;
            per_store_data_prev[item.store_id]['non_repeat_visitors'] += item.first;
            per_store_data_prev[item.store_id]['favorites'] += item.favorites;
          } else if (item.dpindex > current_end) {
            if (!(item.store_id in per_store_data_next)) {
              per_store_data_next[item.store_id] = {
                reservations: 0,
                visit_duration: 0,
                repeat_visitors: 0,
                non_repeat_visitors: 0,
                favorites: 0
              }
            }
            per_store_data_next[item.store_id]['reservations'] += item.active;
            per_store_data_next[item.store_id]['visit_duration'] += item.duration;
            per_store_data_next[item.store_id]['repeat_visitors'] += item.active - item.first;
            per_store_data_next[item.store_id]['non_repeat_visitors'] += item.first;
            per_store_data_next[item.store_id]['favorites'] += item.favorites;
          }
        }
        for (var dp_to_include_index = 0; dp_to_include_index < this.current_mode_data.dp_to_include.length; dp_to_include_index++) {
          new_current_visit_duration[new_current_visit_duration] = Math.ceil(new_current_visit_duration[new_current_visit_duration] / new_current_visit_duration_divider[new_current_visit_duration])
        }

        for (var key in store_id_to_index) {
          new_current_visit_duration_all_stores_details[key] = Math.ceil(new_current_visit_duration_all_stores_details[key] / new_current_visit_duration_all_stores_details_divider[key])
        }
        this.current_visitors_total = new_current_visitors_total
        this.current_visitors_expired = new_current_visitors_expired
        this.current_visitors_completed = new_current_visitors_completed
        this.current_visitors_active = new_current_visitors_active
        this.current_visitors_cancelled = new_current_visitors_cancelled
        this.current_favorites = new_current_favorites
        this.total_stats = total_stats
        this.current_favorites_all_stores_details = new_current_favorites_all_stores_details
        this.current_total_reservations_all_stores_details = new_current_total_reservations_all_stores_details
        this.current_visit_duration = new_current_visit_duration
        this.current_visit_duration_all_stores_details = new_current_visit_duration_all_stores_details
        this.current_repeat_visitors = new_current_repeat_visitors
        this.per_store_data = per_store_data

        this.per_store_data_prev = per_store_data_prev
        this.per_store_data_next = per_store_data_next
        this.unknown_by_store = unknown_by_store
        this.loading_dashboards = false
      }, 500),

      async loadItemsInline() {
        this.compare_in_line = undefined;
        if (this.showVisitors && this.dashboard_mode === 'store_in_brand') {
          var compare_in_line = [
            {
              name: 'In Line',
              store_1: 0,
              store_2: 0,
            },
            {
              name: 'Forecast',
              store_1: 0,
              store_2: 0,
            },
            {
              name: 'Expired',
              store_1: 0,
              store_2: 0,
            },
          ]
          var result = await fetchItemsNextTokenGraphQL(listReservations, {
            filter: {
              and: {
                iscancelled: {eq: 0},
                or: [
                  {store_id: {eq: this.store.id}},
                  {store_id: {eq: this.store_to_compare_object.id}}
                ],
                enterdt: {
                  between: [Math.floor(moment().add(-1, "day").unix()), Math.ceil(moment().add(1, "day").unix())]
                },
              }
            },
            limit: 100000
          })

          for (var el of result) {
            var st_id = el.store_id == this.store.id ? 'store_1' : 'store_2'
            if (!el.leavedt) {
              if (moment.unix(el.enterdt) < moment().add(-300, 'minutes')) {

              } else {
                if (moment.unix(el.enterdt) > moment().add(-this.store.minutes_before_out, 'minutes')) {
                  compare_in_line[0][st_id] += 1;
                } else {
                  compare_in_line[2][st_id] += 1
                }
              }
            }
          }
          for (var el of result) {
            if (!el.leavedt) {
              if (moment.unix(el.enterdt) < moment().add(-300, 'minutes')) {

              } else {
                if (moment.unix(el.enterdt) > moment().add(-this.store.minutes_before_out, 'minutes')) {
                  compare_in_line[0][st_id] += 1;
                }
              }
            }
          }

          var result = await fetchItemsNextTokenGraphQL(listReservations, {
            filter: {
              and: {
                iscancelled: {eq: 0},
                or: [
                  {store_id: {eq: this.store.id}},
                  {store_id: {eq: this.store_to_compare_object.id}}
                ],
                dt: {
                  between: [moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).subtract(this.store.minutes_before_expire, 'minute').unix(),

                    moment.utc(moment.tz(this.store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(30, 'minute').unix()]
                },
              }
            },
            limit: 100000
          })
          for (var el of result) {
            if (!el.enterdt) {
              var st_id = el.store_id == this.store.id ? 'store_1' : 'store_2'
              compare_in_line[1][st_id] += 1;
            }
          }
        }
        this.compare_in_line = compare_in_line
        return result;


      },
      async loadCompareData() {
        this.loading_compare = true;
        this.loadItemsInline();
        this.per_store_data_compared_a = {}
        this.per_store_data_compared_b = {}
        this.compare_visitors_total_a = []
        this.compare_visitors_expired_a = []
        this.compare_visitors_completed_a = []
        this.compare_visitors_active_a = []
        this.compare_visitors_cancelled_a = []
        this.compare_visit_duration_a = []
        this.compare_repeat_visitors_a = [0, 0]


        this.compare_visitors_total_b = []
        this.compare_visitors_expired_b = []
        this.compare_visitors_completed_b = []
        this.compare_visitors_active_b = []
        this.compare_visitors_cancelled_b = []
        this.compare_visit_duration_b = []
        this.compare_repeat_visitors_b = [0, 0]
        var per_store_data_compared_a = {}
        var per_store_data_compared_b = {}
        var compare_stats = [{
          'Total': 0,
          'Expired': 0,
          'Completed': 0,
          'Active': 0,
          'Cancelled': 0,
        },
          {
            'Total': 0,
            'Expired': 0,
            'Completed': 0,
            'Active': 0,
            'Cancelled': 0,
          }]

        var filter_a = {
          and:
            {
              dptype: {eq: this.compare_mode_data_a.type},
              dpindex: {
                between: [Math.floor(this.compare_mode_data_a.start), Math.ceil(this.compare_mode_data_a.end)]
              },
            }
        }

        var filter_b = {
          and:
            {
              dptype: {eq: this.compare_mode_data_b.type},
              dpindex: {
                between: [Math.floor(this.compare_mode_data_b.start), Math.ceil(this.compare_mode_data_b.end)]
              },
            }
        }

        if (this.dashboard_mode === 'brand') {
          filter_a['and']['or'] = []
          filter_b['and']['or'] = []
          for (var br of this.allStoresInCurrentBrand) {
            filter_a['and']['or'].push({'store_id': {eq: br.id}})
            filter_b['and']['or'].push({'store_id': {eq: br.id}})
          }
        } else if (this.dashboard_mode === 'store') {
          filter_a['and']['store_id'] = {eq: this.store.id}
          filter_b['and']['store_id'] = {eq: this.store.id}
        } else if (this.dashboard_mode === 'store_in_brand') {

          filter_a['and']['store_id'] = {eq: this.store.id}
          filter_b['and']['store_id'] = {eq: this.store_to_compare_object.id}
        }

        var result_a = await fetchItemsNextTokenGraphQL(listDashboardStoreStats, {

          filter: filter_a,
          limit: 100000
        })

        var result_b = await fetchItemsNextTokenGraphQL(listDashboardStoreStats, {
          filter: filter_b,
          limit: 100000
        })


        var new_compare_visitors_total_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visitors_expired_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visitors_completed_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visitors_active_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visitors_cancelled_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visit_duration_a = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_visit_duration_a_divider = new Array(this.compare_mode_data_a.labels.length).fill(0);
        var new_compare_favorites = [0, 0]
        var new_compare_repeat_visitors_a = [0, 0]


        for (var item of result_a) {


          for (var dp_to_include_index = 0; dp_to_include_index < this.compare_mode_data_a.dp_to_include.length; dp_to_include_index++) {
            if (this.compare_mode_data_a.dp_to_include[dp_to_include_index].includes(item.dpindex)) {
              var dp_store = this.getStoreById(item.store_id)
              var current_dp_id_0 = Math.floor(moment.utc(moment.tz(dp_store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-dp_store.minutes_before_expire, 'minutes').unix() / 60 / 60)
              var current_dp_id_1 = moment.utc(moment.tz(dp_store.timezone).format("YYYY-MM-DDTHH:mm:ss")).startOf('day').unix() / 60 / 60 / 24;

              compare_stats[0]['Total'] += item.active
              compare_stats[0]['Cancelled'] += item.cancelled
              compare_stats[0]['Completed'] += item.completed
              var active = item.active - item.completed - item.cancelled


              if (this.compare_mode_data_a.type == 0) {
                if (item.dpindex >= current_dp_id_0) {
                  compare_stats[0]['Active'] += active
                } else {
                  compare_stats[0]['Expired'] += active
                }
              } else {
                if (item.dpindex >= current_dp_id_1) {
                  compare_stats[0]['Active'] += active
                } else {
                  compare_stats[0]['Expired'] += active
                }
              }
              if (!(item.store_id in per_store_data_compared_a)) {
                per_store_data_compared_a[item.store_id] = {
                  reservations: 0,
                  visit_duration: 0,
                  repeat_visitors: 0,
                  non_repeat_visitors: 0,
                  favorites: 0
                }
              }
              new_compare_favorites[0] += item.favorites;
              new_compare_visitors_total_a[dp_to_include_index] += item.active
              new_compare_visitors_completed_a[dp_to_include_index] += item.completed
              new_compare_visitors_cancelled_a[dp_to_include_index] += item.cancelled
              new_compare_visit_duration_a[dp_to_include_index] += item.duration
              new_compare_visit_duration_a_divider[dp_to_include_index] += item.completed
              new_compare_repeat_visitors_a[0] += item.active - item.first
              new_compare_repeat_visitors_a[1] += item.first
              per_store_data_compared_a[item.store_id]['reservations'] += item.active;
              per_store_data_compared_a[item.store_id]['visit_duration'] += item.duration;
              per_store_data_compared_a[item.store_id]['repeat_visitors'] += item.active - item.first;
              per_store_data_compared_a[item.store_id]['non_repeat_visitors'] += item.first;
              per_store_data_compared_a[item.store_id]['favorites'] += item.favorites;
              if (this.compare_mode_data_a.type == 0) {
                if (item.dpindex >= current_dp_id_0) {
                  new_compare_visitors_active_a[dp_to_include_index] += active
                } else {
                  new_compare_visitors_expired_a[dp_to_include_index] += active
                }
              } else {
                if (item.dpindex >= current_dp_id_1) {
                  new_compare_visitors_active_a[dp_to_include_index] += active
                } else {
                  new_compare_visitors_expired_a[dp_to_include_index] += active
                }
              }
            }
          }
        }


        var new_compare_visitors_total_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visitors_expired_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visitors_completed_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visitors_active_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visitors_cancelled_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visit_duration_b = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_visit_duration_b_divider = new Array(this.compare_mode_data_b.labels.length).fill(0);
        var new_compare_repeat_visitors_b = [0, 0]

        for (var item of result_b) {
          for (var dp_to_include_index = 0; dp_to_include_index < this.compare_mode_data_b.dp_to_include.length; dp_to_include_index++) {
            if (this.compare_mode_data_b.dp_to_include[dp_to_include_index].includes(item.dpindex)) {

              var active = item.active - item.completed - item.cancelled
              compare_stats[1]['Total'] += item.active
              compare_stats[1]['Cancelled'] += item.cancelled
              compare_stats[1]['Completed'] += item.completed
              if (this.compare_mode_data_b.type == 0) {

                if (item.dpindex >= current_dp_id_0) {
                  compare_stats[1]['Active'] += active
                } else {
                  compare_stats[1]['Expired'] += active
                }
              } else {
                if (item.dpindex >= current_dp_id_1) {
                  compare_stats[1]['Active'] += active
                } else {
                  compare_stats[1]['Expired'] += active
                }
              }

              console.log("current_dp_id_0 : ",this.current_dp_id_0);
              console.log("item.dpindex : ",item.dpindex);



              if (!(item.store_id in per_store_data_compared_b)) {
                per_store_data_compared_b[item.store_id] = {
                  reservations: 0,
                  visit_duration: 0,
                  repeat_visitors: 0,
                  non_repeat_visitors: 0,
                  favorites: 0
                }
              }
              new_compare_favorites[1] += item.favorites;
              new_compare_visitors_total_b[dp_to_include_index] += item.active
              new_compare_visitors_completed_b[dp_to_include_index] += item.completed
              new_compare_visitors_cancelled_b[dp_to_include_index] += item.cancelled
              new_compare_visit_duration_b[dp_to_include_index] += item.duration
              new_compare_visit_duration_b_divider[dp_to_include_index] += item.completed
              new_compare_repeat_visitors_b[0] += item.active - item.first
              new_compare_repeat_visitors_b[1] += item.first
              per_store_data_compared_b[item.store_id]['reservations'] += item.active;
              per_store_data_compared_b[item.store_id]['visit_duration'] += item.duration;
              per_store_data_compared_b[item.store_id]['repeat_visitors'] += item.active - item.first;
              per_store_data_compared_b[item.store_id]['non_repeat_visitors'] += item.first;
              per_store_data_compared_b[item.store_id]['favorites'] += item.favorites;
              if (this.compare_mode_data_b.type == 0) {
                if (item.dpindex >= current_dp_id_0) {
                  new_compare_visitors_active_b[dp_to_include_index] += active
                } else {
                  new_compare_visitors_expired_b[dp_to_include_index] += active
                }
              } else {
                if (item.dpindex >= current_dp_id_1) {
                  new_compare_visitors_active_b[dp_to_include_index] += active
                } else {
                  new_compare_visitors_expired_b[dp_to_include_index] += active
                }
              }
            }
          }
        }
        for (var dp_to_include_index = 0; dp_to_include_index < this.compare_mode_data_a.dp_to_include.length; dp_to_include_index++) {
          new_compare_visit_duration_a[dp_to_include_index] = Math.floor(new_compare_visit_duration_a[dp_to_include_index] / new_compare_visit_duration_a_divider[dp_to_include_index])
        }
        for (var dp_to_include_index = 0; dp_to_include_index < this.compare_mode_data_b.dp_to_include.length; dp_to_include_index++) {
          new_compare_visit_duration_b[dp_to_include_index] = Math.floor(new_compare_visit_duration_b[dp_to_include_index] / new_compare_visit_duration_b_divider[dp_to_include_index])
        }


        this.compare_total_reservations_a = new_compare_visitors_total_a
        this.compare_total_reservations_b = new_compare_visitors_total_b
        this.compare_total_reservations_all_stores_a = new_compare_visitors_total_a
        this.compare_total_reservations_all_stores_b = new_compare_visitors_total_b

        this.compare_visitors_total_a = new_compare_visitors_total_a
        this.compare_visitors_expired_a = new_compare_visitors_expired_a
        this.compare_visitors_completed_a = new_compare_visitors_completed_a
        this.compare_visitors_active_a = new_compare_visitors_active_a
        this.compare_visitors_cancelled_a = new_compare_visitors_cancelled_a
        this.compare_visit_duration_a = new_compare_visit_duration_a
        this.compare_repeat_visitors_a = new_compare_repeat_visitors_a

        this.compare_visitors_total_b = new_compare_visitors_total_b
        this.compare_visitors_expired_b = new_compare_visitors_expired_b
        this.compare_visitors_completed_b = new_compare_visitors_completed_b
        this.compare_visitors_active_b = new_compare_visitors_active_b
        this.compare_visitors_cancelled_b = new_compare_visitors_cancelled_b
        this.compare_visit_duration_b = new_compare_visit_duration_b
        this.compare_repeat_visitors_b = new_compare_repeat_visitors_b
        this.per_store_data_compared_a = per_store_data_compared_a
        this.per_store_data_compared_b = per_store_data_compared_b
        this.compare_stats = compare_stats
        this.compare_favorites = new_compare_favorites
        var max = 1;
        for (var value of new_compare_visitors_total_a) {
          if (value > max) {
            max = value;
          }
        }
        for (var value of new_compare_visitors_total_b) {
          if (value > max) {
            max = value;
          }
        }
        this.compareMax = max;
        this.loading_compare = false
      },
      adjustedComparisonTitle(order) {
        return this.compare_mods[this.compare_mods_slider]['title'].slice(0, -1) + ` ${order}`
      },
      toggleOverlay() {
        this.overlay = !this.overlay
      },
      formattedDate(date) {
        if (date) {
          if (this.compare_mods_slider === 0) {
            return moment(date).format('dddd, MMMM Do YYYY')
          }
          if (this.compare_mods_slider === 1) {
            return `From ${moment(date).format('MMM Do')} to ${moment(date).add(6, 'd').format('MMM Do')}`
          }
          if (this.compare_mods_slider === 2) {
            return moment(date).format('MMMM YYYY')
          }
          if (this.compare_mods_slider === 3) {
            return moment(date).format('YYYY')
          }
        } else {
          return ''
        }
      },
      pickerValue(date) {
        if (this.compare_mods_slider === 0) {
          return moment(date).format('YYYY MM DD')
        }
        if (this.compare_mods_slider === 1) {
          return [moment(date).format('YYYY MM DD'), moment(date).add(6, 'd').format('YYYY MM DD')]
        }
        if (this.compare_mods_slider === 2) {
          return moment(date).format('YYYY MM')
        }
        if (this.compare_mods_slider === 3) {
          return moment(date).year()
        }
      },
      allowedDates: val => moment(val).isoWeekday() === 1,
      allDates: val => val,
      modeChanged(val) {
        this.formatted_date = val.formatted_date
        this.backup = val.mode
        this.mode = val.mode
        this.custom_data_range_first = val.data_range[0]
        this.custom_data_range_second = val.data_range[1]
        this.compare = false
        this.loadDashboardData(true)
        this.loadCurrentlyInStore()
      },
      cancelCompare() {
        this.modeChanged({
          mode: this.backup,
          data_range: [this.custom_data_range_first, this.custom_data_range_second]
        })
      },
      compareStores() {
        this.compare_display_label = this.compare_param
        this.compare = true
        if (this.compare_param === 'Dates') {
          this.store_to_compare_object = this.store
        } else {
          this.dateB = this.dateA
        }
        this.store_to_compare = this.store_to_compare_object.name
        this.loadCompareData()
      },
      selectStoreToCompare(store) {
        this.store_to_compare = store.name
        this.store_to_compare_object = store
        this.panels = null

      },
      saveDate(picker, date) {
        this.$refs[picker].save(date)
        if (this.compare_mods_slider === 0) {
          this.$refs[picker].activePicker = 'DATE'
        }
        if (this.compare_mods_slider === 1) {
          this.$refs[picker].activePicker = 'DATE'
        }
        if (this.compare_mods_slider === 2) {
          this.$refs[picker].activePicker = 'MONTH'
        }
        if (this.compare_mods_slider === 3) {
          this.$refs[picker].activePicker = 'YEAR'
        }
      },
      compareModeChanged() {
        this.dateA = ''
        this.dateB = ''
      },
      compareDates(field, date) {
        this.$refs[field].save(date)
      },
      build_compare_mode(compare_mode, date) {
        switch (compare_mode) {
          case 0:
            var labels = []
            var dp_to_include = []
            var start = moment.utc(date).startOf('day');
            var end = moment.utc(date).endOf('day');
            while (start < end) {
              labels.push(start.format("hh A"))
              dp_to_include.push([start.unix() / 60 / 60])
              start.add(1, 'hour')
            }
            return {
              'type': 0,
              'start': moment.utc(date).startOf('day').unix() / 60 / 60,
              'end': moment.utc(date).endOf('day').unix() / 60 / 60,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
          case 1:
            dp_to_include = []
            var start = moment.utc(date).startOf('isoWeek').unix() / 60 / 60
            for (var i = 0; i < 7; i++) {
              var in_day = []
              for (var k = 0; k < 24; k++) {
                in_day.push(start + i * 24 + k)
              }
              dp_to_include.push(in_day)
            }
            return {
              'type': 0,
              'start': start,
              'end': moment.utc(date).endOf('isoWeek').unix() / 60 / 60,
              'labels': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              'dp_to_include': dp_to_include
            }
          case 2:
            var labels = []
            var dp_to_include = []
            var start = moment.utc(date).startOf('month')
            var month = start.month()
            while (start.month() == month) {
              labels.push(start.date())
              dp_to_include.push([start.unix() / 60 / 60 / 24])
              start.add(1, 'day')
            }
            return {
              'type': 1,
              'start': moment.utc(date).startOf('month').unix() / 60 / 60 / 24,
              'end': moment.utc(date).endOf('month').unix() / 60 / 60 / 24,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
          case 3:
            var dp_to_include = []
            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            var start = moment.utc(date).startOf('year')
            var initial_year = start.year()
            while (start.year() == initial_year) {
              start.add(1, "day")
              dp_to_include[start.month()].push(start.unix() / 60 / 60 / 24)
            }

            return {
              'type': 1,
              'start': moment.utc(date).startOf('year').unix() / 60 / 60 / 24,
              'end': moment.utc(date).endOf('year').unix() / 60 / 60 / 24,
              'labels': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              'dp_to_include': dp_to_include
            }
        }
      },
       calculateReserveDateTime(dateTimeString){
      var storeTime = new DateTime.fromISO(dateTimeString, {
        zone: this.store.timezone
      });
      var storeUTC = storeTime.toUTC();
      var storemillisecond = (storeUTC).toMillis()/ 1000;

      return storemillisecond;

    }
    },
    data: function () {
      return {
        adjusted_active: {},
        compare_display_label: '',
        compare_param: 'Dates',
        formatted_date: 'Today',
        expired_faded: false,
        active_faded: false,
        cancelled_faded: false,
        completed_faded: false,
        settings: {
          swipeEasing: true,
          suppressScrollY: false,
          suppressScrollX: true,
          wheelPropagation: false
        },
        visitors_for_today: 0,
        compare_in_line: undefined,
        store_to_compare: '',
        store_to_compare_object: {},
        search: '',
        panels: null,
        currently_in_store_expired: 0,
        dialog: false,
        currently_in_store_loading: true,
        loading_dashboards: true,
        loading_compare: false,
        current_time: undefined,
        coming_next_30_minutes: 0,
        currently_in_store: 0,
        timer: undefined,
        reload_timer: undefined,
        dateA: '',
        dateB: '',
        compare: false,
        overlay: false,
        mode: 'Day',
        backup: 'Day',
        compare_mods_slider: 0,
        compare_mods: [
          {'title': 'Days', 'disabled': false, 'datapicker_type': 'DATE'},
          {'title': 'Weeks', 'disabled': false, 'datapicker_type': 'DATE'},
          {'title': 'Months', 'disabled': false, 'datapicker_type': "MONTH"},
          {'title': 'Years', 'disabled': false, 'datapicker_type': 'YEAR'}
        ],
        compare_date_first: false,
        compare_date_second: false,
        custom_data_range_first: moment(),
        custom_data_range_second: moment(),
        total_stats: {
          'Total': undefined,
          'Expired': undefined,
          'Completed': undefined,
          'Active': undefined,
          'Cancelled': undefined,
          'Unknown': 0
        },
        compare_stats: [{
          'Total': undefined,
          'Expired': undefined,
          'Completed': undefined,
          'Active': undefined,
          'Cancelled': undefined,
        }, {
          'Total': undefined,
          'Expired': undefined,
          'Completed': undefined,
          'Active': undefined,
          'Cancelled': undefined,
        }],
        per_store_data_compared_a: {},
        per_store_data_compared_b: {},
        per_store_data: {},
        per_store_data_prev: {},
        per_store_data_next: {},
        unknown_by_store: {},
        current_repeat_visitors: [],
        current_visit_duration: [],
        current_favorites: [],
        compare_repeat_visitors_a: [],
        compare_repeat_visitors_b: [],
        compare_visit_duration_a: [],
        compare_visit_duration_b: [],
        compare_total_reservations_a: [],
        compare_total_reservations_b: [],
        compare_favorites: [0, 0],
        current_visitors_total: [],
        current_visitors_expired: [],
        current_visitors_completed: [],
        current_visitors_active: [],
        current_visitors_cancelled: [],
        compare_visitors_total_a: [],
        compare_visitors_expired_a: [],
        compare_visitors_completed_a: [],
        compare_visitors_active_a: [],
        compare_visitors_cancelled_a: [],
        compare_visitors_total_b: [],
        compare_visitors_expired_b: [],
        compare_visitors_completed_b: [],
        compare_visitors_active_b: [],
        compare_visitors_cancelled_b: [],
        current_visit_duration_all_stores_details: [],
        current_total_reservations_all_stores_details: [],
        current_favorites_all_stores_details: [],
        compare_total_reservations_all_stores_a: [],
        compare_total_reservations_all_stores_b: [],
        compareMax: 1,
      }
    },
    mounted: function () {

      this.currently_in_store_loading = true;
      this.loadCurrentlyInStore()
      this.timer = setInterval(this.updateTime, 30000)
      this.updateTime()
      this.reload_timer = setInterval(() => {
        this.loadDashboardData(false)
        this.loadCurrentlyInStore()
      }, 60000)
      this.loadDashboardData(true)

    },
    beforeDestroy() {
      clearTimeout(this.timer)
      clearTimeout(this.reload_timer)
    },
    computed: {
      ...mapGetters(['loadingState', 'allStoresInCurrentBrand', 'getCurrentStore', 'getStoreById', 'getBrandById', 'getCurrentBrand',]),
      storeId() {
        return this.store.id
      },
      questionable_start() {
        var results = {}
        var all_stores = [this.store];
        if (this.dashboard_mode == 'brand') {
          all_stores = this.allStoresInCurrentBrand
        }
        for (var store of all_stores) {
          var expired_data_point_id_hours_start = Math.floor(moment.utc(moment.tz(store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-store.minutes_before_expire, 'minutes').unix() / 60 / 60)
          var expired_data_point_id_days_start = Math.floor(moment.utc(moment.tz(store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-store.minutes_before_expire, 'minutes').startOf('day').unix() / 60 / 60 / 24);
          results[store.id] = expired_data_point_id_hours_start * 60 * 60
          if (this.current_mode_data.type != 0) {
            results[store.id] = expired_data_point_id_days_start * 60 * 60 * 24
          }
          return results
        }
      },
      questionable_end() {
        var result = {}
        for (var store_id in this.questionable_start) {
          result[store_id] = this.questionable_start[store_id] + 60 * 60
          if (this.current_mode_data.type != 0) {
            result[store_id] = this.questionable_start[store_id] + 60 * 60 * 24
          }
        }
        return result
      },
      questionable_index() {
        var results = {}
        for (var store_id in this.questionable_start) {
          var index = this.questionable_start[store_id] / 60 / 60;
          if (this.current_mode_data.type != 0) {
            index = index / 24
          }
          for (var dp_to_include_index = 0; dp_to_include_index < this.current_mode_data.dp_to_include.length; dp_to_include_index++) {
            if (this.current_mode_data.dp_to_include[dp_to_include_index].includes(index)) {
              results[store_id] = dp_to_include_index
            }
          }
        }
        return results === {} ? undefined : results;
      },
      adjusted_current_visitors_active() {

        if (this.questionable_index !== undefined) {
          var new_array = new Array(this.current_visitors_active.length)
          for (var i = 0; i < this.current_visitors_active.length; i++) {
            new_array[i] = this.current_visitors_active[i]
          }
          for (var store_id in this.questionable_index) {
            if (this.adjusted_active[store_id] !== undefined) {
              new_array[this.questionable_index[store_id]] += this.adjusted_active[store_id];
            } else {
              new_array[this.questionable_index[store_id]] += this.unknown_by_store[store_id]
            }
          }
          return new_array
        } else {
          return this.current_visitors_active
        }
      },
      adjusted_current_visitors_expired() {
        if (this.questionable_index !== undefined) {
          var new_array = new Array(this.current_visitors_expired.length)
          for (var i = 0; i < this.current_visitors_expired.length; i++) {
            new_array[i] = this.current_visitors_expired[i]
          }
          for (var store_id in this.questionable_index) {
            if (this.adjusted_active[store_id] !== undefined && this.unknown_by_store[store_id] !== undefined) {
              new_array[this.questionable_index[store_id]] += this.unknown_by_store[store_id] - this.adjusted_active[store_id];
            }
          }
          return new_array
        } else {
          return this.current_visitors_expired
        }
      },
      tableLabelPrev() {
        let first_date = moment(this.custom_data_range_first).subtract(1, this.mode).startOf(this.mode)
        let second_date = moment(this.custom_data_range_first).subtract(1, this.mode).endOf(this.mode)
        if (moment(first_date).isSame(second_date, 'day')) {
          return `${this.formattedDate(first_date)} `
        }
        return `${this.formattedDate(first_date)} ~ ${this.formattedDate(second_date)} `
      },
      tableLabel() {
        let first_date = moment(this.custom_data_range_first).startOf(this.mode)
        let second_date = moment(this.custom_data_range_first).endOf(this.mode)
        if (moment(first_date).isSame(second_date, 'day')) {
          return `${this.formattedDate(first_date)} `
        }
        return `${this.formattedDate(first_date)} ~ ${this.formattedDate(second_date)} `
      },
      tableLabelNext() {
        let first_date = moment(this.custom_data_range_first).add(1, this.mode).startOf(this.mode)
        let second_date = moment(this.custom_data_range_first).add(1, this.mode).endOf(this.mode)
        if (moment(first_date).isSame(second_date, 'day')) {
          return `${this.formattedDate(first_date)} `
        }
        return `${this.formattedDate(first_date)} ~ ${this.formattedDate(second_date)} `
      },

      per_store_data_for_all_stores() {
        if (!this.compare) {
          if (this.dashboard_mode == 'brand') {
            var per_store_data_for_all_stores = []
            for (var store of this.allStoresInCurrentBrand) {
              if (store.id in this.per_store_data) {
                per_store_data_for_all_stores.push({
                  ...this.per_store_data[store.id],
                  name: store.name,
                  duration: store.duration
                })
              } else {
                per_store_data_for_all_stores.push({
                  name: store.name,
                  reservations: 0,
                  visit_duration: 0,
                  repeat_visitors: 0,
                  non_repeat_visitors: 0,
                  favorites: 0,
                  duration: store.duration
                })
              }
            }
            return per_store_data_for_all_stores
          } else {
            var per_store_data_for_all_stores = []
            if (this.store.id in this.per_store_data_prev) {
              per_store_data_for_all_stores.push({
                ...this.per_store_data_prev[this.store.id],
                name: this.tableLabelPrev,
                duration: this.store.duration
              })
            } else {
              per_store_data_for_all_stores.push({
                name: this.tableLabelPrev,
                reservations: 0,
                visit_duration: 0,
                repeat_visitors: 0,
                non_repeat_visitors: 0,
                favorites: 0,
                duration: this.store.duration
              })
            }

            if (this.store.id in this.per_store_data) {
              per_store_data_for_all_stores.push({
                ...this.per_store_data[this.store.id],
                name: this.tableLabel,
                duration: this.store.duration
              })
            } else {
              per_store_data_for_all_stores.push({
                name: this.tableLabel,
                reservations: 0,
                visit_duration: 0,
                repeat_visitors: 0,
                non_repeat_visitors: 0,
                favorites: 0,
                duration: this.store.duration
              })
            }


            if (this.store.id in this.per_store_data_next) {
              per_store_data_for_all_stores.push({
                ...this.per_store_data_next[this.store.id],
                name: this.tableLabelNext,
                duration: this.store.duration
              })
            } else {
              per_store_data_for_all_stores.push({
                name: this.tableLabelNext,
                reservations: 0,
                visit_duration: 0,
                repeat_visitors: 0,
                non_repeat_visitors: 0,
                favorites: 0,
                duration: this.store.duration
              })
            }
            return per_store_data_for_all_stores
          }
        } else {
          var per_store_data_for_all_stores = []
          let data_a = this.per_store_data_compared_a[this.store.id]
          if (data_a === undefined) {
            data_a = {
              'reservations': 0,
              'visit_duration': 0,
              'repeat_visitors': 0,
              'non_repeat_visitors': 0,
              'favorites': 0
            }
          }
          let data_b = this.per_store_data_compared_b[this.store_to_compare_object.id]
          if (data_b === undefined) {
            data_b = {
              'reservations': 0,
              'visit_duration': 0,
              'repeat_visitors': 0,
              'non_repeat_visitors': 0,
              'favorites': 0
            }
          }
          per_store_data_for_all_stores.push({
              ...data_a,
              name: this.compare_display_label === 'Stores' ? this.store.name : this.formattedDate(this.dateA),
              duration: this.store.duration
            },
            {
              ...data_b,
              name: this.compare_display_label === 'Stores' ? this.store_to_compare_object.name : this.formattedDate(this.dateB),
              duration: this.store_to_compare_object.duration
            })


          return per_store_data_for_all_stores

        }
      },
      getRepeatVisitorsValue() {
        let total_visitors = this.current_repeat_visitors[0] + this.current_repeat_visitors[1]
        return Math.ceil(100 * this.current_repeat_visitors[0] / total_visitors)
      },
      bottom_table_items_store() {
        let get_average = function (array) {
          let filtered = array.filter(item => item !== 0)
          if (filtered.length) {
            let sum = filtered.reduce((a, b) => a + b, 0) / filtered.length
            return sum
          } else {
            return 0
          }
        }
        return [
          {
            date: this.formatted_date,
            total: this.total_stats['Total'],
            avg_visit: get_average(this.current_visit_duration),
            repeat_visitors: this.current_repeat_visitors,
            favorites: this.current_favorites.filter(item => item !== 0)

          }
        ]
      },
      bottom_table_headers() {
        return [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'store',
          },
          {
            text: 'Total Reservations',
            align: 'start',
            sortable: false,
            value: 'total',
          },
          {
            text: 'Avg. Visit (min)',
            value: 'avg_visit',

          },
          {text: 'Repeat Visitors', value: 'repeat_visitors'},
          {text: 'Favorites', value: 'favorites'},

        ]
      },
      dashboardLoaded() {
        return !this.loading_dashboards && !this.loading_compare
      },
      showVisitors() {
        if (this.compare) {
          return this.dateA === moment().format('YYYY-MM-DD') && this.dateB === moment().format('YYYY-MM-DD')
        } else {
          return true
        }
      },
      compareHeadersInLine() {
        return [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {text: this.compare_param === 'Dates' ? this.formattedDate(this.dateA) : this.store.name, value: 'store_1'},
          {
            text: this.compare_param === 'Dates' ? this.formattedDate(this.dateB) : this.store_to_compare,
            value: 'store_2'
          },
        ]
      },
      compareHeaders() {
        return [
          {
            text: '',
            value: 'store_or_date'
          },
          {
            text: 'Total Registered',
            value: 'total'
          },
          {
            text: 'Expired',
            value: 'expired'
          },
          {
            text: 'Completed',
            value: 'completed'
          },
          {
            text: 'Active',
            value: 'active'
          },
          {
            text: 'Cancelled',
            value: 'cancelled'
          },

        ]
      },
      compareItems() {
        return [
          {
            store_or_date: this.compare_display_label === 'Dates' ? this.formattedDate(this.dateA) : this.store.name,
            total: this.compare_stats[0]['Total'],
            expired: this.compare_stats[0]['Expired'],
            completed: this.compare_stats[0]['Completed'],
            active: this.compare_stats[0]['Active'],
            cancelled: this.compare_stats[0]['Cancelled']
          },
          {
            store_or_date: this.compare_display_label === 'Dates' ? this.formattedDate(this.dateB) : this.store_to_compare,
            total: this.compare_stats[1]['Total'],
            expired: this.compare_stats[1]['Expired'],
            completed: this.compare_stats[1]['Completed'],
            active: this.compare_stats[1]['Active'],
            cancelled: this.compare_stats[1]['Cancelled']

          }
        ]

      },
      storeToCompare() {
        if (this.store_to_compare) {
          return this.store_to_compare
        } else {
          return 'Not Set'
        }
      },
      applyDisabled() {
        if (this.dashboard_mode === 'store_in_brand' && this.compare_param === 'Stores') {
          return (this.dateA.length < 1 || !this.store_to_compare_object.hasOwnProperty('name'))
        } else
          return this.dateA.length < 1 || this.dateB.length < 1
      },

      chartdataFavoritesCompared() {
        return {
          labels: [this.store.name, this.store_to_compare],
          datasets: [
            {
              label: 'Favorites',
              data: this.compare_favorites,
              backgroundColor: ['#1765C0', '#5EB7E5'],
              borderColor: 'white',
              borderWidth: 1,
            },
          ]
        }
      },
      settingsFavoritesCompared() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataTotalReservationsCompared() {
        return {
          labels: this.compare_mode_data_a.labels,
          datasets: [
            {
              fill: false,
              label: this.store.name,
              data: this.compare_total_reservations_a,
              backgroundColor: '#1765C0',
              borderColor: '#1765C0',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
            {
              fill: false,
              label: this.store_to_compare,
              data: this.compare_total_reservations_b,
              backgroundColor: '#5EB7E5',
              borderColor: '#5EB7E5',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsTotalReservationsCompared() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataVisitDurationCompared() {
        return {
          labels: this.compare_mode_data_a.labels,
          datasets: [
            {
              fill: false,
              label: this.store.name,
              data: this.compare_visit_duration_a.map(item => Math.ceil(item / 60)),
              backgroundColor: '#1765C0',
              borderColor: '#1765C0',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
            {
              fill: false,
              label: this.store_to_compare,
              data: this.compare_visit_duration_b.map(item => Math.ceil(item / 60)),
              backgroundColor: '#5EB7E5',
              borderColor: '#5EB7E5',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsVisitDurationCompared() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataRepeatedVisitorsCompared() {
        return {
          labels: [this.store.name, this.store_to_compare],
          datasets: [
            {
              label: 'First Time Visitors',
              data: [this.compare_repeat_visitors_a[1], this.compare_repeat_visitors_b[1]],
              backgroundColor: ['#1765C0', '#1765C0'],
              borderColor: 'white',
              borderWidth: 1,
            },
            {
              label: 'Repeat Visitors',
              data: [this.compare_repeat_visitors_a[0], this.compare_repeat_visitors_b[0]],
              backgroundColor: ['#5EB7E5', '#5EB7E5'],
              borderColor: 'white',
              borderWidth: 1,
            },
          ]
        }
      },
      settingsRepeatedVisitorsCompared() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },

      chartdataRepeatedVisitors() {
        return {
          labels: ['Repeat Visitors', 'First Time Visitors'],
          datasets: [
            {
              label: 'Visitors',
              data: this.current_repeat_visitors,
              backgroundColor: ['#5EB7E5', '#1765C0'],
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsRepeatedVisitors() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataVisitDuration() {
        return {
          labels: this.current_mode_data.labels,
          datasets: [
            {
              label: 'Visit Duration',
              data: this.current_visit_duration.map(item => Math.ceil(item / 60)),
              backgroundColor: '#1765C0',
              borderColor: '#1765C0',
              borderWidth: 2,
              fill: false,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsVisitDuration() {
        return {

          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataTotalReservations() {
        return {
          labels: this.current_mode_data.labels,
          datasets: [
            {
              label: 'Total Reservation',
              data: this.current_visitors_total,
              backgroundColor: '#1765C0',
              borderColor: '#1765C0',
              borderWidth: 2,
              fill: false,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsTotalReservations() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataFavorites() {
        return {
          labels: this.current_mode_data.labels,
          datasets: [
            {
              label: 'Favorites Count',
              data: this.current_favorites,
              backgroundColor: '#1765C0',
              borderColor: '#1765C0',
              borderWidth: 2,
              fill: false,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsFavorites() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },

      chartdataFavoritesComparedAllStores() {
        return {
          labels: [this.dateA, this.dateB],
          datasets: [
            {
              label: 'Favorites',
              data: this.compare_favorites,
              backgroundColor: ['#1765C0', '#5EB7E5'],
              borderColor: 'white',
              borderWidth: 1,
            },
          ]
        }
      },
      settingsFavoritesComparedAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                display: false
              },
              gridLines: {
                display: false
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataTotalReservationsComparedAllStores() {
        return {
          labels: this.compare_mode_data_a.labels,
          datasets: [
            {
              fill: false,
              label: this.dateA,
              data: this.compare_total_reservations_all_stores_a,
              backgroundColor: Array.from(new Array(12), () => '#1765C0'),
              borderColor: '#1765C0',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
            {
              fill: false,
              label: this.dateB,
              data: this.compare_total_reservations_all_stores_b,
              backgroundColor: '#5EB7E5',
              borderColor: '#5EB7E5',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsTotalReservationsComparedAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataVisitDurationComparedAllStores() {
        return {
          labels: this.compare_mode_data_a.labels,
          datasets: [
            {
              fill: false,
              label: this.dateA,
              data: this.compare_visit_duration_a.map(item => Math.ceil(item / 60)),
              backgroundColor: Array.from(new Array(12), () => '#1765C0'),
              borderColor: '#1765C0',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
            {
              fill: false,
              label: this.dateB,
              data: this.compare_visit_duration_b.map(item => Math.ceil(item / 60)),
              backgroundColor: '#5EB7E5',
              borderColor: '#5EB7E5',
              borderWidth: 2,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsVisitDurationComparedAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataRepeatedVisitorsComparedAllStores() {
        return {
          labels: [this.dateA, this.dateB],
          datasets: [
            {
              label: 'First Time Visitors',
              data: [this.compare_repeat_visitors_a[1], this.compare_repeat_visitors_b[1]],
              backgroundColor: ['#1765C0', '#1765C0'],
              borderColor: 'white',
              borderWidth: 1,
            },
            {
              label: 'Repeat Visitors',
              data: [this.compare_repeat_visitors_a[0], this.compare_repeat_visitors_b[0]],
              backgroundColor: ['#5EB7E5', '#5EB7E5'],
              borderColor: 'white',
              borderWidth: 1,
            },
          ]
        }
      },
      settingsRepeatedVisitorsComparedAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              fontColor: '#1565c0'
            }
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },

      chartdataRepeatedVisitorsAllStores() {
        return {
          labels: ['Repeat Visitors', 'First Time Visitors'],
          datasets: [
            {
              label: 'Visitors',
              data: this.current_repeat_visitors,
              backgroundColor: ['#5EB7E5', '#1765C0'],
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsRepeatedVisitorsAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataVisitDurationAllStores() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Visit Duration',
              data: this.current_visit_duration_all_stores_details.map(item => Math.ceil(item / 60)),
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      chartdataVisitDurationAllStoresDetails() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Visit Duration',
              data: this.current_visit_duration_all_stores_details.map(item => Math.ceil(item / 60)),
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsVisitDurationAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataTotalReservationsAllStores() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Total Reservations',
              data: this.current_total_reservations_all_stores_details,
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      chartdataTotalReservationsAllStoresDetails() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Total Reservations',
              data: this.current_total_reservations_all_stores_details,
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      settingsTotalReservationsAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      settingsFavoritesAllStores() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: false
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: false
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      chartdataFavoritesAllStores() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Favorites',
              data: this.current_favorites_all_stores_details,
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      chartdataFavoritesAllStoresDetails() {
        return {
          labels: this.allStoresInCurrentBrand.map(item => item.name),
          datasets: [
            {
              label: 'Favorites',
              data: this.current_favorites_all_stores_details,
              backgroundColor: '#1765C0',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
            },
          ]
        }
      },
      dashboard_mode() {
        return this.$route.meta.mode
      },
      allowDrawer() {
        return this.$route.meta.drawer_needed
      },
      compareDataPickerType() {
        return this.compare_mods[this.compare_mods_slider]['datapicker_type']
      },
      drawerState() {
        return this.$store.state.drawer_state
      },
      compare_mode_data_a() {
        return this.build_compare_mode(this.compare_mods_slider, this.dateA)
      },
      compare_mode_data_b() {
        return this.build_compare_mode(this.compare_mods_slider, this.dateB)
      },
      current_mode_data() {

        switch (this.mode) {
          case 'Day':
            var labels = []
            var dp_to_include = []
            if (this.dashboard_mode === 'brand') {
              var start = moment.utc(this.custom_data_range_first.format("YYYY-MM-DDT") + "00:00")
              var end = moment.utc(this.custom_data_range_first.format("YYYY-MM-DDT") + "23:59:59")
            } else {
              var start = moment.utc(this.custom_data_range_first.format("YYYY-MM-DDT") + "00:00")
              var start_prefix = getPrefixFromMoment(start)
              var prev_day_prefix = getPrefixFromMoment(moment(start).add(-1, 'days'))
              if (this.store['open_time_' + prev_day_prefix] <= this.store['close_time_' + prev_day_prefix])
                start.add(this.store['open_time_' + start_prefix], 'minute')

              if (this.store['open_time_' + start_prefix] <= this.store['close_time_' + start_prefix])
                var end = moment(moment.utc(this.custom_data_range_first.format("YYYY-MM-DDT") + "00:00")).add(this.store['close_time_' + start_prefix], 'minute')
              else
                var end = moment.utc(this.custom_data_range_first.format("YYYY-MM-DDT") + "23:59:59")
            }
            var start_index = start.unix() / 60 / 60;
            var end_index = end.unix() / 60 / 60;

            while (start < end) {
              labels.push(start.format("hh A"))
              dp_to_include.push([start.unix() / 60 / 60])
              start.add(1, 'hour')
            }
            return {
              'type': 0,
              'start': start_index,
              'end': end_index,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
          case 'Week':
            var start = moment(this.custom_data_range_first).utc().startOf('week').startOf('day')
            var end = moment(this.custom_data_range_second).utc().endOf('day')
            if (start > end) {
              var t = end.startOf('day');
              end = start.endOf('day');
              start = t;
            }
            var st_adjusted = moment(start)
            var end_adjusted = moment(end)
            var labels = []
            var dp_to_include = []
          {
            while (start <= end) {

              labels.push(start.utc().format("MMM D"))
              dp_to_include.push([Math.floor(start.utc().unix() / 60 / 60 / 24)])
              start.add(1, "day")
            }
          }

            return {
              'type': 1,
              'start': st_adjusted.unix() / 60 / 60 / 24,
              'end': end_adjusted.unix() / 60 / 60 / 24,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
          case 'Month':

            var start = moment(this.custom_data_range_first).utc().startOf('month').startOf('day')
            var end = moment(this.custom_data_range_second).utc().endOf('month').endOf('day')



            if (start > end) {
              var t = end.startOf('day');
              end = start.endOf('day');
              start = t;
            }
            var st_adjusted = moment(start)
            var end_adjusted = moment(end)
            var labels = []
            var dp_to_include = []
          {
            while (start <= end) {

              labels.push(start.utc().format("MMM D"))
              dp_to_include.push([Math.floor(start.utc().unix() / 60 / 60 / 24)])
              start.add(1, "day")
            }
          }

           console.log("month first : ",this.custom_data_range_first);
            console.log("month second : ",this.custom_data_range_second);
            console.log("start : ",start);
            console.log("end : ",end);
             console.log("st_adjusted : ",st_adjusted);
            console.log("end_adjusted : ",end_adjusted);
            console.log("st_adjusted.unix() / 60 / 60 / 24 : ",st_adjusted.unix() / 60 / 60 / 24);
            console.log("end_adjusted.unix() / 60 / 60 / 24 : ",end_adjusted.unix() / 60 / 60 / 24);

            return {
              'type': 1,
              'start': st_adjusted.unix() / 60 / 60 / 24,
              'end': end_adjusted.unix() / 60 / 60 / 24,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
          case 'Year':
            var dp_to_include = []
            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            dp_to_include.push([])
            dp_to_include.push([])
            dp_to_include.push([])

            var start = moment(this.custom_data_range_second).utc().startOf('year')
            var initial_year = start.year()
            while (start.year() == initial_year) {
              start.add(1, "day")
              dp_to_include[start.month()].push(start.unix() / 60 / 60 / 24)
            }

            return {
              'type': 1,
              'start': moment(this.custom_data_range_first).utc().startOf('year').unix() / 60 / 60 / 24,
              'end': moment(this.custom_data_range_second).utc().endOf('year').unix() / 60 / 60 / 24,
              'labels': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              'dp_to_include': dp_to_include
            }
          case 'Custom':
            var start = moment(this.custom_data_range_first).utc().startOf('day')
            var end = moment(this.custom_data_range_second).utc().endOf('day')
            if (start > end) {
              var t = end.startOf('day');
              end = start.endOf('day');
              start = t;
            }
            var st_adjusted = moment(start)
            var end_adjusted = moment(end)
            var labels = []
            var dp_to_include = []
          {
            while (start <= end) {

              labels.push(start.utc().format("MMM D"))
              dp_to_include.push([Math.floor(start.utc().unix() / 60 / 60 / 24)])
              start.add(1, "day")
            }
          }

            return {
              'type': 1,
              'start': st_adjusted.unix() / 60 / 60 / 24,
              'end': end_adjusted.unix() / 60 / 60 / 24,
              'labels': labels,
              'dp_to_include': dp_to_include
            }
        }
      },

      store() {
        //TODO not sure about this approach
        if (this.dashboard_mode === 'store') {
          return this.getStoreById(this.getCurrentStore)
        }
        if (this.dashboard_mode === 'brand') {
          //TODO don't know what to do here, for development purposes just using the first store
          return this.allStoresInCurrentBrand[0]
        }
        if (this.dashboard_mode === 'store_in_brand') {
          return this.getStoreById(this.$route.params.store_id)
        }
      },
      brand() {
        return this.getBrandById(this.getCurrentBrand)
      },

      linechartVisitorsSettings() {
        return {
          maintainAspectRatio: false,
          layout: {
            // padding: {
            //   left: 75,
            //   right: 75,
            //   top: 80,
            //   bottom: 80,
            // }
          },
          scales: {
            xAxes: [{
              ticks: {
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
            }],
            yAxes: [{

              ticks: {
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                drawBorder: true,
                display: false
              },
            }]
          },
          responsive: true,
          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
        }
      },
      settingsVisitors() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 80,
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: true
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: true
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      settingsVisitorsComparedA() {
        return {
          layout: {
            padding: {
              top: 80,
              bottom: 0,
            }
          },

          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {

                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false
              },
              stacked: true
            }],
            yAxes: [{
              ticks: {
                reverse: false,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true,
                suggestedMax: this.compareMax
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: true
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      settingsVisitorsComparedB() {
        return {
          layout: {
            padding: {
              top: 0,
              bottom: 80,
            }
          },
          tooltips: {
            enabled: true,
            backgroundColor: 'white',
            titleFontColor: '#1565c0',
            bodyFontColor: '#1565c0',
            footerFontColor: '#1565c0',
            borderColor: 'rgba(21,101,192, .5)',
            borderWidth: 1
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                fontColor: "rgba(21,101,192, 0)",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true
              },
              gridLines: {
                display: false,
              },
              stacked: true
            }],
            yAxes: [{
              ticks: {
                reverse: true,
                fontColor: "#1565c0",
                maxRotation: 0,
                minRotation: 0,
                beginAtZero: true,
                suggestedMax: this.compareMax
              },
              gridLines: {
                borderDash: [5, 5],
                borderDashOffset: 2,
                color: "rgba(21,101,192, .1)"
              },
              stacked: true
            }]
          },
          responsive: true,
          maintainAspectRatio: false
        }
      },
      linechartVisitorsTotal() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [{
            data: this.current_visitors_total,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          }]
        }

      },
      linechartVisitorsCompleted() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [{
            data: this.current_visitors_completed,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          }]
        }
      },
      linechartVisitorsExpired() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [{
            data: this.adjusted_current_visitors_expired,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          }]
        }
      },
      linechartVisitorsActive() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [{
            data: this.adjusted_current_visitors_active,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          }]
        }
      },
      linechartVisitorsCancelled() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [{
            data: this.current_visitors_cancelled,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          }]
        }
      },

      linechartVisitorsComparedTotal() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [{
            label: this.formattedDate(this.dateA),
            data: this.compare_visitors_total_a,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          },
            {
              label: this.formattedDate(this.dateB),
              data: this.compare_visitors_total_b,
              lineTension: 0,
              fill: false,
              borderWidth: 1,
              borderColor: '#5EB7E5',
              backgroundColor: 'transparent',
              pointBorderColor: '#5EB7E5',
              pointBackgroundColor: 'white',
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 1,
              pointStyle: 'rectRounded',
            }]
        }

      },
      linechartVisitorsComparedCompleted() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [{
            label: this.formattedDate(this.dateA),
            data: this.compare_visitors_completed_a,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          },
            {
              label: this.formattedDate(this.dateB),
              data: this.compare_visitors_completed_b,
              lineTension: 0,
              fill: false,
              borderWidth: 1,
              borderColor: '#5EB7E5',
              backgroundColor: 'transparent',
              pointBorderColor: '#5EB7E5',
              pointBackgroundColor: 'white',
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 1,
              pointStyle: 'rectRounded',
            }]
        }
      },
      linechartVisitorsComparedExpired() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [{
            label: this.formattedDate(this.dateA),
            data: this.compare_visitors_expired_a,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          },
            {
              label: this.formattedDate(this.dateB),
              data: this.compare_visitors_expired_b,
              lineTension: 0,
              fill: false,
              borderWidth: 1,
              borderColor: '#5EB7E5',
              backgroundColor: 'transparent',
              pointBorderColor: '#5EB7E5',
              pointBackgroundColor: 'white',
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 1,
              pointStyle: 'rectRounded',
            }]
        }
      },
      linechartVisitorsComparedActive() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [{
            label: this.formattedDate(this.dateA),
            data: this.compare_visitors_active_a,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          },
            {
              label: this.formattedDate(this.dateB),
              data: this.compare_visitors_active_b,
              lineTension: 0,
              fill: false,
              borderWidth: 1,
              borderColor: '#5EB7E5',
              backgroundColor: 'transparent',
              pointBorderColor: '#5EB7E5',
              pointBackgroundColor: 'white',
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 1,
              pointStyle: 'rectRounded',
            }]
        }
      },
      linechartVisitorsComparedCancelled() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [{
            label: this.formattedDate(this.dateA),
            data: this.compare_visitors_active_a,
            lineTension: 0,
            fill: false,
            borderWidth: 2,
            borderColor: 'rgba(21,101,192, 1)',
            backgroundColor: 'transparent',
            pointBorderColor: 'rgba(21,101,192, 1)',
            pointBackgroundColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 1,
            pointStyle: 'rectRounded',
          },
            {
              label: this.formattedDate(this.dateB),
              data: this.compare_visitors_active_b,
              lineTension: 0,
              fill: false,
              borderWidth: 1,
              borderColor: '#5EB7E5',
              backgroundColor: 'transparent',
              pointBorderColor: '#5EB7E5',
              pointBackgroundColor: 'white',
              pointRadius: 5,
              pointHoverRadius: 10,
              pointHitRadius: 30,
              pointBorderWidth: 1,
              pointStyle: 'rectRounded',
            }]
        }
      },

      chartdataVisitors_compare_a() {
        return {
          'labels': this.compare_mode_data_a.labels,
          'datasets': [
            {
              label: 'Expired',
              data: this.compare_visitors_expired_a,
              backgroundColor: 'rgba(254,104,104, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Cancelled',
              data: this.compare_visitors_cancelled_a,
              backgroundColor: 'rgba(163,176,191, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Completed',
              data: this.compare_visitors_completed_a,
              backgroundColor: 'rgba(21,101,192, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Active',
              data: this.compare_visitors_active_a,
              backgroundColor: 'rgba(118,205,121, .6)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
          ]
        }
      },
      chartdataVisitors_compare_b() {
        return {
          'labels': this.compare_mode_data_b.labels,
          'datasets': [
            {
              label: 'Expired',
              data: this.compare_visitors_expired_b,
              backgroundColor: 'rgba(254,104,104, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Cancelled',
              data: this.compare_visitors_cancelled_b,
              backgroundColor: 'rgba(163,176,191, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Completed',
              data: this.compare_visitors_completed_b,
              backgroundColor: 'rgba(21,101,192, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Active',
              data: this.compare_visitors_active_b,
              backgroundColor: 'rgba(118,205,121, .6)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
          ]
        }
      },
      chartdataVisitors() {
        return {
          'labels': this.current_mode_data.labels,
          'datasets': [
            {
              label: 'Expired',
              data: this.adjusted_current_visitors_expired,
              backgroundColor: this.expired_faded ? 'rgba(254,104,104, .2)' : 'rgba(254,104,104, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Cancelled',
              data: this.current_visitors_cancelled,
              backgroundColor: this.cancelled_faded ? 'rgba(163,176,191, .2)' : 'rgba(163,176,191, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Completed',
              data: this.current_visitors_completed,
              backgroundColor: this.completed_faded ? 'rgba(21,101,192, .2)' : 'rgba(21,101,192, 1)',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
            {
              label: 'Active',
              data: this.adjusted_current_visitors_active,
              backgroundColor: this.active_faded ? 'rgba(118,205,121, .2)' : 'rgba(118,205,121, 1)',
              borderColor: 'white',
              borderWidth: 1,
              borderSkipped: ['bottom', 'left', 'right'],
              barPercentage: 1.18,
            },
          ]
        }
      }
    }

  }

</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .chart-label-top {
    margin-bottom: -64px;
    display: grid;
    grid-template-columns: 1fr auto;

  }

  .chart-label-bottom {
    margin-top: -96px;

  }

  .title-store {
    display: grid !important;
    grid-template-columns: 1fr auto;

    .v-list-item__subtitle {
      grid-row-start: 2;
    }

    .v-icon {
      grid-column-start: 2;
      grid-row-start: 1;
      grid-column-end: 2;
      grid-row-end: 3;
    }
  }

  .custom-store-selector {
    max-width: 320px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: .5rem;
    padding: 1rem;

    &:after {
      display: none;
    }
  }

  .avg-visit-int {
    min-width: 2rem;
  }

  .avg-visit-progress {
    max-width: 100px;
    align-self: center;
    margin: 0 10px;
  }

  .loader {
    text-align: -webkit-center;
    opacity: .7;
    margin-top: 20vh;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin-top: 15vh;
    }
  }

  .v-data-table {


    .item-name {
      font-weight: 500;


    }

    .positive-num {
      color: #76CD79;
    }

    .negative-num {
      color: #FE6868;
    }
  }

  .scroll-area {
    margin: 0 -20px;
    padding: 1rem;
    position: relative;
    height: calc(100vh - 604px);
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      height: calc(100vh - 500px);
    }

    .store-item {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: 1rem;
    }

    .title-card {

      color: black;
      padding: 1rem 2rem;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: .12px;
      position: absolute;
      left: 0;
      right: 0px;
      height: 70px;

      &.active {
        background-color: #F5F9FD !important;
        color: var(--v-primary-base);
      }

      .card-content {

      }
    }

    .search-transition {


    }
  }

  .compare-info {
    align-items: center;
    color: var(--v-primary-base);
    display: grid;
    grid-template-columns: 100px 1fr 100px;
    background-color: #EEF3F9;
    margin: -20px;
    position: fixed;
    padding: 10px 2rem;
    top: 68px;
    z-index: 1;
    width: 100vw;
    transition: .4s;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 10px;
    }

    &.adjusted-to-drawer {
      @media #{map-get($display-breakpoints, 'lg-and-up')} {
        padding-right: 420px;
        transition: .4s;
      }

    }

  }


  .compare-dates {
    .v-btn {
      max-height: 36px !important;
      font-weight: 400 !important;
      color: #3565BA;
      text-transform: none !important;

      &.compare_mode_active {
        background-color: #3565BA !important;
        color: white !important;
      }
    }


  }

  .dashboard-content {

    .title-name-card {
      border: none !important;
      @media #{map-get($display-breakpoints, 'sm-and-up')} {
        border: 1px solid #1765C03C !important;

      }
    }

    .v-list-item__content {
      padding: 0 !important;
    }

    &.store {
      padding: 2rem 2rem;
      width: 100%;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        padding: 2rem 0;
      }

      .store-title {
        display: grid;
        grid-template-columns: 1fr auto;
        font-weight: 600;
        place-self: center;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          text-align: -webkit-center;
          grid-template-columns: 1fr;
        }

        .v-btn {
          margin-top: 2rem;

          &.cancel-btn {
            margin-top: 1rem;
          }
        }

        .v-icon {
          font-size: 22px;
        }

        .title-name {

          letter-spacing: 0.18px;
          font-size: 24px;
        }

        .title-address {
          color: black;
          letter-spacing: 0.11px;
          font-size: 16px;
        }

      }

      .upper-content {
        padding: 2rem 0;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {


        }


        .store-visitors {

          text-align: -webkit-center;

          .progress-inner {

            color: #1565C0;

            .inner-visitors {
              line-height: 28px;
              font-size: 36px;
              font-weight: 600;
            }

            .inner-text {
              font-size: 14px;
              font-weight: 600;
            }

            .inner-max {
              font-size: 12px;
            }
          }
        }


      }


      .compare-btns {

        margin-left: 20rem;
        @media #{map-get($display-breakpoints, 'md-and-down')} {
          margin: 0;
        }
      }

      .chart-container {
        overflow-x: hidden;
        position: relative;
        @media #{map-get($display-breakpoints, 'lg-and-up')} {
        }
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          padding: 0;
        }


        &.compared {
          display: grid;
          grid-auto-rows: 1fr 1fr;
          @media #{map-get($display-breakpoints, 'xs-only')} {

          }
        }


      }

      .bottom-charts-container {

        color: var(--v-primary-base);
        font-weight: 500;
        @media #{map-get($display-breakpoints, 'md-and-down')} {


        }
      }


    }

    &.brand {
      padding: 2rem 0;
      width: 100%;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
      }

      .upper-content {
        padding: 2rem 0;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {

          place-items: center;

        }


      }

      .store-title {
        padding-top: 2rem;

        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 1rem;
        font-weight: 600;
        place-self: start;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          grid-template-columns: 1fr;
          .activator {
            .v-btn {
              width: 100%;
            }
          }
        }


        .v-icon {
          font-size: 22px;
        }

        .title-name {
          align-items: center;
          grid-gap: .6rem;
          display: grid;
          grid-template-columns: auto 1fr;
          letter-spacing: 0.18px;
          font-size: 24px;
        }

        .title-address {
          color: black;
          letter-spacing: 0.11px;
          font-size: 16px;
        }

      }

      .bottom-charts-container {
        padding-top: 2rem;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
        }

        .details-btn-container {
          display: grid;
          grid-template-columns: 1fr auto;
          grid-gap: 1rem;
        }

        .graph-body {
          position: relative;
          width: 30vw;
          @media #{map-get($display-breakpoints, 'xs-only')} {


          }
          @media #{map-get($display-breakpoints, 'lg-only')} {
            width: 24vw;


          }
          @media #{map-get($display-breakpoints, 'sm-only')} {
          }

        }

        &.expanded {
          .graph-body {
            width: 42vw;
            @media #{map-get($display-breakpoints, 'md-only')} {
              width: 36vw;
            }
            @media #{map-get($display-breakpoints, 'sm-only')} {
              width: 80vw;
            }
            @media #{map-get($display-breakpoints, 'xs-only')} {
              width: 67vw;
            }


          }


        }


      }

    }

    &.store_in_brand {
      padding: 2rem 0;
      width: 100%;

      .visitors-info {
        margin-top: -2rem;

        .circular-item {
          justify-self: center;
          text-align: center;

          .circular-title {
            margin-bottom: 1rem;
            font-weight: 500;
            color: black;
          }
        }

        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          grid-template-columns: 1fr;
        }

        &.compare {
          grid-template-columns: .5fr .5fr 1fr;
          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            grid-template-columns: 1fr 1fr;
            .line-table {
              grid-column-start: 1;
              grid-column-end: 3;
            }
          }
          @media #{map-get($display-breakpoints, 'xs-only')} {
            display: block;
            .circular-item {
              margin-bottom: 2rem;
            }
          }
        }
      }

      .overflowing-image {
        position: absolute;
        right: 14px;
      }

      .store-title {
        padding-top: 2rem;

        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 1rem;
        font-weight: 600;
        place-self: start;
        @media #{map-get($display-breakpoints, 'xs-only')} {
          grid-template-columns: 1fr;
          .activator {
            .v-btn {
              width: 100%;
            }
          }
        }


        .v-icon {
          font-size: 22px;
        }

        .activator {
          align-self: center;
        }

        .title-name {
          align-items: center;
          grid-gap: .6rem;
          display: grid;
          grid-template-columns: auto 1fr;
          letter-spacing: 0.18px;
          font-size: 24px;

          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            .v-list-item {
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 62vw;
            }
          }

        }

        .title-address {
          color: black;
          letter-spacing: 0.11px;
          font-size: 16px;
        }

      }

      .bottom-charts-container {
        padding-top: 2rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 4rem;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          grid-template-columns: 1fr;
        }

        .details-btn-container {
          display: grid;
          grid-template-columns: 1fr auto;
          grid-gap: 1rem;
        }

        .graph-body {
          position: relative;
          width: 30vw;
          @media #{map-get($display-breakpoints, 'xs-only')} {


          }
          @media #{map-get($display-breakpoints, 'lg-only')} {
            width: 24vw;


          }
          @media #{map-get($display-breakpoints, 'sm-only')} {
          }

        }

        &.expanded {
          .graph-body {
            width: 42vw;
            @media #{map-get($display-breakpoints, 'md-only')} {
              width: 36vw;
            }
            @media #{map-get($display-breakpoints, 'sm-only')} {
              width: 80vw;
            }
            @media #{map-get($display-breakpoints, 'xs-only')} {
              width: 67vw;
            }


          }


        }


      }
    }

  }

</style>
<style>
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: #C2D4EB !important;
  }
</style>



// WEBPACK FOOTER //
// src/Stores/StoreDashboard.vue